<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
        <h1 class="page-title fw-bold">Portefeuille des composantes</h1>
        <div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de bord</a></router-link></li>
                <li class="breadcrumb-item active" aria-current="page"><router-link :to="{ name: 'composantes', params: { showList: true }}"><a>Portefeuille</a></router-link></li>
            </ol>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-12" v-if="showList">
            <div class="expanel expanel-default expanel-border">
                <div class="expanel-body text-wrap text-end">
                    <button class="btn btn-outline-primary me-3 fw-bold" @click="showClasseurs">
                        <span class="fe fe-folder"></span> Les classeurs
                    </button>
                    <button class="btn btn-outline-info mt-1 mb-1 me-3 fw-bold" @click="showForm">
                        <span class="fe fe-plus"></span> Nouvelle composante
                    </button>
                    <button class="btn btn-outline-warning mt-1 mb-1 me-3 fw-bold" @click="showMeteos">
                        <span class="fe fe-cloud-lightning"></span> Les Météos
                    </button>
                    <button class="btn btn-outline-success mx-3" @click="showValidationMeteo">
                        <span class="fe fe-check-circle"></span> Validation météos
                    </button>
                    <button class="btn btn-outline-danger mt-1 mb-1 me-3 fw-bold" @click="showAssignationComposantesP4W">
                        <span class="fe fe-paperclip"></span> Assignation de composantes P4W
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12" v-if="showList">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title fw-bold">Liste des composantes</h3>
                    <div class="card-options">
                        <!-- <SearchInputAll></SearchInputAll> -->
                        <!-- <button class="btn btn-info mx-5" @click="showForm"><span class="fe fe-plus"></span> Nouvelle composante</button> -->
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="grid-margin">
                        <div class="panel panel-primary">
                            <div class="panel-body tabs-menu-body border-0 pt-0">
                                <div class="tab-content">
                                    <div class="tab-pane active" id="tab5">
                                        <div class="mb-3">
                                            <div class="mb-3 d-flex">
                                                <div class="form-row col-sm-12">
                                                    <button class="btn btn-primary col-sm-2" title="Les Filtres" @click="showFilter = !showFilter">
                                                        <span><i class="fe fe-filter text-white" style="font-size: 15px;"></i> Filtres</span>
                                                    </button>
                                                    <multi-select class="col-sm-5" @select="o => o.used = true" :options="columns.filter(o => !o.used)" v-if="showFilter"
                                                        :custom-label="v => v.description" placeholder="Filtrer par " label="name" track-by="name"></multi-select>
                                                </div>
                                            </div>
                                            <div class="row" v-if="showFilter">
                                                <div v-for="(item, index) in filters" :key="`filter${index}`" class="form-group col-sm-4">
                                                    <div class="input-group">
                                                        <select v-if="item.options" v-model="item.value" class="form-select">
                                                            <option v-for="(obj, i) in item.options" :key="i" :value="obj.key">{{ obj.value }}</option>
                                                        </select>
                                                        <input v-else :type="item.type" class="form-control" :placeholder="`Recherche de ${item.description}`"
                                                                v-model="item.value">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-danger" type="button" @click="onSearchBack(item)">
                                                                <i class="fe fe-trash-2"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-sm-4" v-if="filters.length > 0">
                                                    <button class="btn btn-dark" tabindex="1" type="button" @click.prevent="onSearch">
                                                        <span><i class="fe fe-search"></i> Appliquer</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="expanel expanel-default">
                                                <div class="expanel-body">
                                                    <div class="row">
                                                        <label class="form-label col-sm-3 fw-bold">Liste des classeurs</label>
                                                        <div class="form-group col-sm-9 d-flex">
                                                            <multi-select deselect-label="Sélectionné" select-label="" :options="classeurs" @select="addTagClasseur(classeur)"
                                                                placeholder="Filtrer par classeur" label="nomClasseur" track-by="idClasseur" :searchable="true"
                                                                :custom-label="o => o.idClasseur + ' - ' + o.nomClasseur" v-model="classeur">
                                                                <template slot="singleLabel" slot-scope="{ option }">
                                                                    <strong> {{ option.nomClasseur }}</strong>
                                                                </template>
                                                            </multi-select>
                                                            <button class="btn btn-dark mx-2" title="Rechercher les composantes par classeur" @click="handleSelectClasseur(classeur)">
                                                                <span><i class="fe fe-search"></i></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="btn-group mt-2">
                                                        <div class="tags ms-2">
                                                            <span class="tag tag-gray" v-for="(tag, index) in tagsClasseurs" :key="index">
                                                                {{ tag.idClasseur }} / {{ tag.nomClasseur }}
                                                                <a href="javascript:void(0)" class="tag-addon" @click="removeTagClasseur(tag)">
                                                                    <i class="fe fe-x"></i>
                                                                </a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="table-responsive mt-3">
                                            <table id="data-table"
                                                class="table table-hover table-bordered text-nowrap mb-0">
                                                <thead class="border-top success02">
                                                    <tr>
                                                        <th class="bg-transparent border-bottom-0 fw-bold" >Actions</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">Id Composante</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Composante</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Etat</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Statut</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Météo</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            TEP Global</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Retard FDR</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Date début planifiée</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Date fin planifiée</th>
                                                        <th class="bg-transparent border-bottom-0 fw-bold">
                                                            Suivi Codir ASIN</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="filtersItems[0]" id="myTable1">
                                                    <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                                        <td class="text-center" >
                                                            <div class="g-2">
                                                                <button type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
                                                                    <span class="fe fe-more-vertical"></span> Déplier <span class="caret"></span>
                                                                </button>
                                                                <ul class="dropdown-menu" role="menu">
                                                                    <li>
                                                                        <button class="modal-effect btn text-dark btn-sm" @click.prevent="showDetail(item)"
                                                                        title="Voir le détail" data-bs-original-title="Voir le détail" data-bs-effect="effect-scale" data-bs-toggle="modal">
                                                                        <span class="fe fe-eye text-warning"></span> Voir le détail</button>
                                                                    </li>
                                                                    <li class="divider"></li>
                                                                    <li>
                                                                        <button class="modal-effect btn text-dark btn-sm" @click.prevent="showHistoriqueMeteo(item)"
                                                                        title="Historique des météos" data-bs-original-title="Historique des météos" data-bs-effect="effect-scale" data-bs-toggle="modal">
                                                                        <span class="fe fe-cloud text-warning"></span> Historique des météos</button>
                                                                    </li>
                                                                    <li class="divider"></li>
                                                                    <li>
                                                                        <button class="modal-effect btn text-dark btn-sm" @click.prevent="showFormMeteo(item)"
                                                                        title="Déclarer une nouvelle météo" data-bs-original-title="Déclarer une nouvelle météo" data-bs-effect="effect-scale" data-bs-toggle="modal">
                                                                        <span class="fe fe-plus-square text-primary"></span> Déclarer une nouvelle météo</button>
                                                                    </li>
                                                                    <li class="divider"></li>
                                                                    <li>
                                                                        <button class="btn text-dark btn-sm" @click.prevent="edit(item)" data-bs-toggle="tooltip" title="Modifier"
                                                                        data-bs-original-title="Modifier"><span class="fe fe-edit text-primary"></span> Modifier une composante</button>
                                                                    </li>
                                                                    <li class="divider"></li>
                                                                    <li>
                                                                        <button class="btn text-dark btn-sm" @click.prevent="drop(item)"
                                                                        data-bs-toggle="tooltip" title="Supprimer" data-bs-original-title="Supprimer">
                                                                        <span class="fe fe-trash-2 text-danger"></span> Supprimer une composante</button>
                                                                    </li>
                                                                </ul>
                                                                <!-- <button class="modal-effect btn text-dark btn-sm" @click.prevent="showModalForLiaisonComposanteP4w(item)"
                                                                    title="Liaison avec P4W" data-bs-original-title="Liaison avec P4W" data-bs-effect="effect-scale" data-bs-toggle="modal">
                                                                    <span class="fe fe-paperclip fs-18"></span></button> -->
                                                                <!-- <button class="modal-effect btn text-info btn-sm" @click.prevent="showPlanifications(item)"
                                                                    title="Voir les planifications" data-bs-original-title="Voir les planifications" data-bs-effect="effect-scale"
                                                                    data-bs-toggle="modal">
                                                                    <span class="fe fe-layers fs-18"></span></button> -->
                                                            </div>
                                                        </td>
                                                        <td class="text-center" >{{ item?.idComposante }}</td>
                                                        <td class="composante-nom" style="width: 25%;">{{ item?.nomComposante }}</td>
                                                        <td class="text-center" >
                                                            <div class="mt-0 mt-sm-3 d-block">
                                                                <span class="p-2 px-3 alert" :style="'background-color: '  + statusEtat(item?.etatComposante?.etat)">{{ item?.etatComposante?.libelle }}</span>
                                                            </div>
                                                        </td>
                                                        <td class="text-center" >
                                                            <div class="mt-0 mt-sm-3 d-block">
                                                                <span class="p-2 px-3 alert" :style="'background-color: '  + statusStatut(item?.statut?.statut)">{{ item?.statut?.libelle }}</span>
                                                            </div>
                                                        </td>
                                                        <td class="text-center" :style="'background-color: '  + couleurMeteo(item?.couleur)">
                                                            <span><small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small></span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="badge bg-success badge-sm me-1 mb-1 mt-1 rounded-pill fw-bold" style="font-size: 13px;">{{ item?.tepGlobal ? item?.tepGlobal : '0' }}</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="mt-0 mt-sm-3 d-block">
                                                                <span :class="'p-2 px-3 alert alert-' + statusRetardFdr(item?.retardFdr)">{{ item?.retardFdr }}</span>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">{{ item?.dateDebutPlanifiee | moment('DD-MM-YYYY') }}</td>
                                                        <td class="text-center">{{ item?.dateFinPlanifiee | moment('DD-MM-YYYY') }}</td>
                                                        <td class="text-center">{{ item?.suiviCodirAsin?.libelle }}</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr class="primary02">
                                                        <td colspan="18" class="text-center">Aucune composante trouvée</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- <nav class="mt-2">
                                            <ul class="pagination justify-content-end">
                                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                    <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                                </li>
                                                <li v-for="page in pageCount" :key="page" class="page-item" :class="{ active: currentPage === page }">
                                                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                                </li>
                                                <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                                    <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                                </li>
                                            </ul>
                                        </nav> -->
                                        <paginate :records="items.totalElements || 0" v-model="items.number" :per-page="items.size"
                                            :options="{ theme: 'bootstrap4', edgeNavigation: true, texts: { count: `{from} à {to} de {count} éléments|{count} éléments|Un élément`, first: '<<<', last: '>>>' } }"
                                            @paginate="onSearch" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="detail-composante" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h6 class="modal-title fw-bold" style="font-size: 16px;">Détail de la Composante</h6><button aria-label="Close" class="btn-close text-white"
                                data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <ul class="row p-3">
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Classeur : </span>
                                    <span>{{ composante?.idClasseur?.idClasseur }} --- {{ composante?.idClasseur?.nomClasseur }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Composante : </span>
                                    <span>{{ composante?.idComposante }} --- {{ composante?.nomComposante }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <div class="mt-0 mt-sm-3 d-block">
                                        <span class="fw-bold">Etat &nbsp;</span>
                                        <span class="p-2 px-3 alert" :style="'background-color: '  + statusEtat(composante?.etatComposante?.etat)">{{ composante?.etatComposante?.libelle }}</span>
                                    </div>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <div class="mt-0 mt-sm-3 d-block">
                                        <span class="fw-bold">Statut &nbsp;</span>
                                        <span class="p-2 px-3 alert" :style="'background-color: '  + statusStatut(composante?.statut?.statut)">{{ composante?.statut?.libelle }}</span>
                                    </div>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Phase actuelle d'exécution : </span>
                                    <span>{{ composante?.phaseExecution?.nomPhase }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Projet PAG : </span>
                                    <span>{{ composante?.idSsProjPag?.idProjetPag?.idProjetPag }} --- {{ composante?.idSsProjPag?.idProjetPag?.nomProjetPag }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Sous Projet PAG : </span>
                                    <span>{{ composante?.idSsProjPag?.idSsProjPag }} --- {{ composante?.idSsProjPag?.nomSsProjPag }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Action PAG : </span>
                                    <span>{{ composante?.idSsProjPag?.idProjetPag?.idAction?.idAction }} --- {{ composante?.idSsProjPag?.idProjetPag?.idAction?.libelleAction }}</span>
                                </li>
                                <li class="col-lg-12 mb-2"><hr></li>

                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Date début planifiée : </span>
                                    <span>{{ composante?.dateDebutPlanifiee | moment('DD-MM-YYYY') }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Date fin planifiée : </span>
                                    <span>{{ composante?.dateFinPlanifiee | moment('DD-MM-YYYY') }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Degré de confidentialité : </span>
                                    <span>{{ composante?.degreConfidentialite?.libelle }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Priorité : </span>
                                    <span>{{ composante?.priorite?.libelle }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <span class="fw-bold">Suivi Codir ASIN : </span>
                                    <span>{{ composante?.suiviCodirAsin?.libelle }}</span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <div class="mt-0 mt-sm-3 d-block">
                                        <span class="fw-bold">Retard Feuille de Route &nbsp;</span>
                                        <span :class="'p-1 px-3 alert alert-' + statusRetardFdr(composante?.retardFdr)">{{ composante?.retardFdr }}</span>
                                    </div>
                                </li>
                                <li class="col-lg-12 mb-2"><hr></li>

                                <li class="col-lg-6 mb-2">
                                    <!-- <span class="fw-bold">Lien Project 4 The Web : </span> -->
                                    <span class=""><a :href="composante?.urlP4w" target="_blank" :class="composante?.urlP4w ? 'btn btn-secondary fw-bold' : 'btn btn-light fw-bold disabled'" role="button">Lien Project 4 The Web</a></span>
                                </li>
                                <li class="col-lg-6 mb-2">
                                    <!-- <span class="fw-bold">Lien SharePoint : </span> -->
                                    <span class=""><a :href="composante?.urlSharepoint" target="_blank" :class="composante?.urlSharepoint ? 'btn btn-secondary fw-bold' : 'btn btn-light fw-bold disabled'" role="button">Lien SharePoint</a></span>
                                </li>
                                <li class="col-lg-12 mb-2"><hr></li>

                                <li class="col-lg-12 mb-2">
                                    <table class="table table-hover table-bordered">
                                        <tr class="text-center info02">
                                            <th colspan="4" class="fw-bold">Référents</th>
                                        </tr>
                                        <tr class="bg-light">
                                            <th colspan="2" class="fw-bold">DAF</th>
                                            <th class="fw-bold">SPM</th>
                                            <th class="fw-bold">PMO</th>
                                        </tr>
                                        <tr>
                                            <td colspan="2">{{ composante?.dafReferent?.contact }}</td>
                                            <td>{{ composante?.spmReferent?.contact }}</td>
                                            <td>{{ composante?.pmoReferent?.contact }}</td>
                                        </tr>
                                        <tr class="text-center info02">
                                            <th colspan="4" class="fw-bold">Ressources ASIN</th>
                                        </tr>
                                        <tr class="bg-light">
                                            <th class="fw-bold">Chef Projet</th>
                                            <th class="fw-bold">Pôle</th>
                                            <th class="fw-bold">Rôle</th>
                                            <th class="fw-bold">TimeSheet Responsable</th>
                                        </tr>
                                        <tr>
                                            <td>{{ composante?.chefProjet?.contact }}</td>
                                            <td>{{ composante?.poleAsin?.nomPole }}</td>
                                            <td>{{ composante?.roleAsin?.nomRole }}</td>
                                            <td>{{ composante?.timesheetResponsable?.contact }}</td>
                                        </tr>
                                        <!-- <tr class="bg-light">
                                            <th colspan="2" class="fw-bold">Cotech Président</th>
                                            <th class="fw-bold">Copil Président</th>
                                            <th class="fw-bold">Cojur Président</th>
                                        </tr>
                                        <tr>
                                            <td colspan="2">{{ composante?.cotechPresident?.contact }}</td>
                                            <td>{{ composante?.copilPresident?.contact }}</td>
                                            <td>{{ composante?.cojurPresident?.contact }}</td>
                                        </tr> -->
                                        <tr class="text-center info02">
                                            <th colspan="4" class="fw-bold">Montants</th>
                                        </tr>
                                        <tr class="bg-light">
                                            <th colspan="2" class="fw-bold">Capex</th>
                                            <th colspan="2" class="fw-bold">Opex</th>
                                        </tr>
                                        <tr>
                                            <td colspan="2">{{ composante?.capex }}</td>
                                            <td colspan="2">{{ composante?.opex }}</td>
                                        </tr>
                                    </table>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-dark" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="planification-composante" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h6 class="modal-title fw-bold" style="font-size: 16px;">Les planifications de la composante</h6><button aria-label="Close" class="btn-close text-white"
                                data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <ul class="row p-3">
                                <li class="col-lg-12 mb-2">
                                    <h4 class="fw-bold">Composante : {{ composante?.idComposante }} --- {{ composante?.nomComposante }}</h4>
                                </li>

                                <li class="col-lg-12 mb-2">
                                    <table class="table table-hover table-bordered">
                                        <tr class="text-center info02">
                                            <th colspan="4" class="fw-bold">Planifications</th>
                                        </tr>
                                        <tr class="bg-light">
                                            <th class="fw-bold">Année</th>
                                            <th class="fw-bold">Taux planifié</th>
                                            <th class="fw-bold">Montant Capex</th>
                                            <th class="fw-bold">Montant Opex</th>
                                        </tr>
                                        <tr v-for="(planification, index) in planifications" :key="index">
                                            <td>{{ planification?.annee?.annee }}</td>
                                            <td><input type="number" name="tepPlanifie" id="tepPlanifie" v-model="planification.tepPlanifie" class="form-control" @input="calculTaux2()" /></td>
                                            <td><input type="number" name="capexEstime" id="capexEstime" v-model="planification.capexEstime" class="form-control" @input="calculAmountCapex2()" /></td>
                                            <td><input type="number" name="opexEstime" id="opexEstime" v-model="planification.opexEstime" class="form-control" @input="calculAmountOpex2()" /></td>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">Total</td>
                                            <td><input type="number" name="totalTepPlanifie" id="totalTepPlanifie" v-model="totalTepPlanifie" class="form-control" readonly /></td>
                                            <td><input type="number" name="totalCapexEstime" id="totalCapexEstime" v-model="totalCapexEstime" class="form-control" readonly /></td>
                                            <td><input type="number" name="totalOpexEstime" id="totalOpexEstime" v-model="totalOpexEstime" class="form-control" readonly /></td>
                                        </tr>
                                    </table>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-success" @click.prevent="savePlanification(composante?.idComposante, planifications)">Modifier</button>
                            <button class="btn btn-dark" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="liaison-composanteP4w" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h6 class="modal-title fw-bold" style="font-size: 16px;">Relier une Composante Project For the Web</h6><button aria-label="Close" class="btn-close text-white"
                                data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <ul class="row p-3">
                                <li class="col-lg-12 mb-2">
                                    <h4 class="fw-bold">Composante : {{ composante?.idComposante }} --- {{ composante?.nomComposante }}</h4>
                                </li>
                                <li class="col-lg-12 mb-2">
                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <ValidationProvider name="p4wComposanteGuid" rules="" v-slot="{ errors }">
                                                <label class="form-label">Composante Project 4 The Web</label>
                                                <multi-select v-model="composante.p4wComposanteGuid" deselect-label="Sélectionné" select-label="" :options="p4wComposanteGuids"
                                                                placeholder="Sélectionné" label="p4wComposanteSubject" track-by="p4wComposanteGuid" :searchable="true"
                                                                :custom-label="o => o.p4wComposanteSubject" aria-readonly="true" disabled>
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <strong> {{ option.p4wComposanteSubject }}</strong>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <ValidationProvider name="p4wComposanteGuid" rules="" v-slot="{ errors }">
                                                <label class="form-label">Composante Project 4 The Web Disponible</label>
                                                <multi-select v-model="composanteP4wDisponible" deselect-label="Sélectionné" select-label="" :options="composantesP4wDisponibles"
                                                            placeholder="Sélectionné une composante disponible" label="p4wComposanteSubject" track-by="p4wComposanteGuid" :searchable="true"
                                                            :custom-label="o => o.p4wComposanteSubject">
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <strong> {{ option.p4wComposanteSubject }}</strong>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-success" @click.prevent="saveLiaisonComposanteP4W(composante?.idComposante, composanteP4wDisponible)">Modifier</button>
                            <button class="btn btn-dark" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="detail-composante-meteo" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h6 class="modal-title fw-bold" style="font-size: 16px;">Historique des météos de la composante sélectionnée</h6><button aria-label="Close" class="btn-close text-white"
                                data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <ul class="row p-3">
                                <li class="col-lg-12 mb-2">
                                    <h4 class="fw-bold">Composante : {{ composante?.idComposante }} --- {{ composante?.nomComposante }}</h4>
                                </li>
                                <li class="col-lg-12 mb-2">
                                    <div class="table-responsive">
                                        <table class="table table-hover table-bordered">
                                            <thead class="border-top success02">
                                                <tr>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('declaredAt')">
                                                        Date déclaration
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('validated')">
                                                        Validé ?
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('approvedAt')">
                                                        Date validation
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('couleur')">
                                                        Météo
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('etudes')">
                                                        Etudes
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('gouvernance')">
                                                        Gouvernance
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('contrat')">
                                                        Contrat
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('execution')">
                                                        Exécution
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('miseEnService')">
                                                        Mise en service
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold"
                                                        style="width: 5%;">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="filtersItemsMeteos.length > 0" id="myTable1">
                                                <tr v-for="(item, index) in filtersItemsMeteos" :key="index" class="border-bottom">
                                                    <td>{{ item?.declaredAt == 'Invalid date' || item?.declaredAt == null ? '-' : item?.declaredAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                    <td class="text-center">
                                                        <span class="fw-bold badge rounded-pill p-2" :class="item?.validated ? 'bg-success' : 'bg-warning'">{{ item?.validated ? 'OUI' : 'NON' }}</span>
                                                    </td>
                                                    <td>{{ item?.approvedAt == 'Invalid date' || item?.approvedAt == null ? '-' : item?.approvedAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                    <td class="text-center" :style="'background-color: '+ couleurMeteo(item?.couleur)">
                                                        <small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.etudes ? item?.etudes : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.gouvernance ? item?.gouvernance : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.contrat ? item?.contrat : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.execution ? item?.execution : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.miseEnService ? item?.miseEnService : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="g-2 d-flex">
                                                            <button class="btn text-primary btn-sm" @click.prevent="edit(item)"
                                                                data-bs-toggle="tooltip" title="Modifier"
                                                                data-bs-original-title="Edit"><span
                                                                    class="fe fe-edit fs-18"></span></button>
                                                            <button
                                                                class="btn text-danger btn-sm" @click.prevent="drop(item)"
                                                                    data-bs-toggle="tooltip" title="Supprimer"
                                                                    data-bs-original-title="Delete"><span
                                                                        class="fe fe-trash-2 fs-18"></span></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr class="primary02">
                                                    <td colspan="8" class="text-center">Aucune météo trouvée.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav class="mt-2">
                                        <ul class="pagination justify-content-end">
                                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                            </li>
                                            <li v-for="page in pageCountMeteo" :key="page" class="page-item" :class="{ active: currentPage === page }">
                                                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                            </li>
                                            <li class="page-item" :class="{ disabled: currentPage === pageCountMeteo }">
                                                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                            </li>
                                        </ul>
                                    </nav>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-dark" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-12">
                <div class="card overflow-auto">
                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-title fw-bold">{{ save ? 'Création d\'une nouvelle composante' : 'Modification d\'une composante' }}</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <ValidationObserver v-slot="{ handleSubmit }">
                            <form @submit.prevent="handleSubmit(onNextep)">
                                <div class="row mb-2 mx-auto d-flex style_niveau">
                                    <div :class="['col mb-3 px-sm-0 px-1', index < (steps.length - 1) ? 'col-sm' : 'col-sm-auto']"
                                        v-for="(step, index) in steps" :key="'step' + index">
                                        <div :class="['d-flex align-items-center', { 'active': payload.currentStep > index + 1 }]">
                                        <div
                                            class="border border d-flex justify-content-center align-items-center bg-light style_same_height_width_60"
                                            @click.prevent="payload.currentStep = payload.currentStep > index + 1 ? index + 1 : payload.currentStep">
                                            <i class="fe fe-check" v-if="payload.currentStep > index + 1"></i><span v-else>0{{ index + 1 }}</span>
                                        </div>
                                        <div class="progress w-100 rounded-0 d-none d-sm-flex" v-if="index < steps.length - 1">
                                            <div class="progress-bar progress-bar-striped bg-secondary" role="progressbar"
                                            :aria-valuenow="20 * (payload.currentStep - 1)" :aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        </div>
                                        <!-- <p class="text-muted text-center">{{step}}</p>-->
                                    </div>
                                </div>

                                <fieldset v-if="payload.currentStep === 1">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idClasseur" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Classeur <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idClasseur" deselect-label="Sélectionné" select-label="" :options="classeurs"
                                                                placeholder="Sélectionné un classeur" label="nomClasseur" track-by="idClasseur" :searchable="true"
                                                                :custom-label="o => o.idClasseur + ' - ' + o.nomClasseur"
                                                                :class="{ 'is-invalid': !payload.idClasseur && soumissionTentée }">
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <strong> {{ option.nomClasseur }}</strong>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="p4wComposanteGuid" rules="" v-slot="{ errors }">
                                                <label class="form-label">Composante Project 4 The Web</label>
                                                <multi-select v-model="payload.p4wComposanteGuid" deselect-label="Sélectionné" select-label="" :options="p4wComposanteGuids"
                                                                placeholder="Sélectionné" label="p4wComposanteSubject" track-by="p4wComposanteGuid" :searchable="true"
                                                                :custom-label="o => o.p4wComposanteSubject" aria-readonly="true" disabled>
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <strong> {{ option.p4wComposanteSubject }}</strong>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="idComposante" rules="" v-slot="{ errors }">
                                                <label class="form-label">ID Composante <span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="idComposante" v-model="payload.idComposante" placeholder="saisir l'ID de la composante" readonly>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="nomComposante" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Nom Composante <span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="nomComposante" v-model="payload.nomComposante" 
                                                placeholder="saisir le nom de la composante" :class="{ 'is-invalid': !payload.nomComposante && soumissionTentée }">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="statut" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Statut <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.statut" deselect-label="Sélectionné" select-label="" :options="statutComposantes"
                                                                placeholder="Sélectionné le statut" label="libelle" track-by="statut" 
                                                                :searchable="true" @select="handleStatut(payload.statut)"
                                                                :class="{ 'is-invalid': !payload.statut && soumissionTentée }">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idAction" rules="" v-slot="{ errors }">
                                                <label class="form-label">Action PAG <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idAction" deselect-label="Sélectionné" select-label="" :options="actionsPag" @select="handleProjetPag(payload.idAction)"
                                                                placeholder="Sélectionné l'action PAG" label="libelleAction" track-by="idAction" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="etatComposante" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Etat ou Implication ASIN <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.etatComposante" deselect-label="Sélectionné" select-label=""  :options="etatComposantes"
                                                                placeholder="Sélectionné l'état de la composante" label="libelle" track-by="etat" 
                                                                :searchable="true" :class="{ 'is-invalid': !payload.etatComposante && soumissionTentée }">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idProjetPag" rules="" v-slot="{ errors }">
                                                <label class="form-label">Projet PAG <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idProjetPag" deselect-label="Sélectionné" select-label="" :options="projetsPag" @select="handleSsProjetPag(payload.idProjetPag)"
                                                                placeholder="Sélectionné le projet PAG" label="nomProjetPag" track-by="idProjetPag" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="tepGlobal" rules="numeric|min_value:0|max_value:100" v-slot="{ errors }">
                                                <label class="form-label">TEP Global (%) </label>
                                                <input type="text" name="tepGlobal" v-model="payload.tepGlobal" id="tepGlobal" class="form-control" />
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idSsProjPag" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Sous Projet PAG <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.idSsProjPag" deselect-label="Sélectionné" select-label="" :options="sousProjetsPag"
                                                                placeholder="Sélectionné le sous projet PAG" label="nomSsProjPag" 
                                                                :custom-label="v =>v.idSsProjPag + ' - ' + v.nomSsProjPag" track-by="idSsProjPag" 
                                                                :searchable="true" :class="{ 'is-invalid': !payload.isSsProjPag && soumissionTentée }">
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <strong> {{ option.nomSsProjPag }}</strong>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idProgram" rules="" v-slot="{ errors }">
                                                <label class="form-label">Programme Stratégique </label>
                                                <multi-select v-model="payload.idProgram" deselect-label="Sélectionné" select-label=""  :options="programmeStrats"
                                                                placeholder="Sélectionné le programme stratégique" label="nomProgram" track-by="idProgram" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="urlP4w" rules="" v-slot="{ errors }">
                                                <label class="form-label">Lien Project 4 The Web</label>
                                                <input type="text" class="form-control" id="urlP4w" v-model="payload.urlP4w" placeholder="saisir ..." >
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="retardFdr" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Retard Feuille de Route ? <span class="text-danger">*</span></label>
                                                    <label class="custom-switch form-switch me-4">
                                                        <input type="radio" name="retardFdr" class="custom-switch-input" checked value="Non" v-model="payload.retardFdr">
                                                        <span class="custom-switch-indicator"></span>
                                                        <span class="custom-switch-description">Non</span>
                                                    </label>
                                                    <label class="custom-switch form-switch">
                                                        <input type="radio" name="retardFdr" class="custom-switch-input" value="Oui" v-model="payload.retardFdr">
                                                        <span class="custom-switch-indicator"></span>
                                                        <span class="custom-switch-description">Oui</span>
                                                    </label>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="urlSharepoint" rules="" v-slot="{ errors }">
                                                <label class="form-label">Lien SharePoint</label>
                                                <input type="text" class="form-control" id="urlSharepoint" v-model="payload.urlSharepoint" placeholder="saisir ...">
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="dateDebutPlanifiee" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Date début planifiée <span class="text-danger">*</span></label>
                                                <date-pick :language="fr" :bootstrapStyling="true" minimumView="day" name="dateDebutPlanifiee"
                                                    v-model="payload.dateDebutPlanifiee" placeholder="Sélectionner la date de debut planifiée"
                                                    calendar-button-icon="fe fe-calendar" @input="handleGetExercices(payload.dateDebutPlanifiee, payload.dateFinPlanifiee)" 
                                                    :class="{ 'is-invalid': !payload.dateDebutPlanifiee && soumissionTentée }" />
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="dateFinPlanifiee" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Date fin planifiée <span class="text-danger">*</span></label>
                                                <date-pick :language="fr" :bootstrapStyling="true" minimumView="day" name="dateFinPlanifiee"
                                                    v-model="payload.dateFinPlanifiee" placeholder="Sélectionner la date de fin planifiée" @input="handleGetExercices(payload.dateDebutPlanifiee, payload.dateFinPlanifiee)"
                                                    calendar-button-icon="fe fe-calendar" :disabledDates="{ to: calcdate(payload.dateDebutPlanifiee), }" 
                                                    :class="{ 'is-invalid': !payload.dateFinPlanifiee && soumissionTentée }" />
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="idPilier" rules="" v-slot="{ errors }">
                                                <label class="form-label">Pillier Stratégique </label>
                                                <multi-select v-model="payload.idPilier" deselect-label="Sélectionné" select-label="" :options="pillierPlStrats"
                                                                placeholder="Sélectionné le pillier stratégique" label="nomPilier" track-by="idPilier" :searchable="true"
                                                                @select="getObjectifStrategique(payload.idPilier)">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="objectifStrategique" rules="" v-slot="{ errors }">
                                                <label class="form-label">Objectif Stratégique </label>
                                                <textarea name="objectifStrategique" v-model="payload.objectifStrategique" class="form-control" id="objectifStrategique" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="detailProgrammeStrategique" rules="" v-slot="{ errors }">
                                                <label class="form-label">Détail Programme Stratégique </label>
                                                <textarea name="detailProgrammeStrategique" v-model="payload.detailProgrammeStrategique" class="form-control" id="detailProgrammeStrategique" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset v-else-if="payload.currentStep === 2">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="degreConfidentialite" rules="" v-slot="{ errors }">
                                                <label class="form-label">Degré de confidentialité </label>
                                                <multi-select v-model="payload.degreConfidentialite" deselect-label="Sélectionné" select-label=""  :options="degres"
                                                                placeholder="Sélectionné un degré de confidentialité" label="libelle" track-by="degre" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="descriptionEnjeux" rules="" v-slot="{ errors }">
                                                <label class="form-label">Description Enjeux </label>
                                                <textarea name="descriptionEnjeux" v-model="payload.descriptionEnjeux" class="form-control" id="descriptionEnjeux"></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="projetsTributaires" rules="" v-slot="{ errors }">
                                                <label class="form-label">Projets tributaires </label>
                                                <textarea name="projetsTributaires" v-model="payload.projetsTributaires" class="form-control" id="projetsTributaires" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="descriptionExistantBesoin" rules="" v-slot="{ errors }">
                                                <label class="form-label">Description Besoin Existant </label>
                                                <textarea name="descriptionExistantBesoin" v-model="payload.descriptionExistantBesoin" class="form-control" id="descriptionExistantBesoin" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="prerequis" rules="" v-slot="{ errors }">
                                                <label for="prerequis" class="form-label">Prérequis </label>
                                                <textarea name="prerequis" v-model="payload.prerequis" class="form-control" id="prerequis" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="descriptionScenImpl" rules="" v-slot="{ errors }">
                                                <label for="descriptionScenImpl" class="form-label">Description Scénario Implication </label>
                                                <textarea name="descriptionScenImpl" v-model="payload.descriptionScenImpl" class="form-control" id="descriptionScenImpl" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="idProjetRefSectoriel" rules="" v-slot="{ errors }">
                                                <label class="form-label">Id Projet Sectoriel </label>
                                                <textarea name="idProjetRefSectoriel" v-model="payload.idProjetRefSectoriel" class="form-control" id="idProjetRefSectoriel" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="analyseJustif" rules="" v-slot="{ errors }">
                                                <label class="form-label">Analyse justificative </label>
                                                <textarea name="analyseJustif" v-model="payload.analyseJustif" class="form-control" id="analyseJustif" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            <ValidationProvider name="priorite" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Priorité <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.priorite" deselect-label="Sélectionné" select-label=""  :options="priorites"
                                                                placeholder="Sélectionné une priorité" label="libelle" track-by="priorite" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <ValidationProvider name="suiviCodirAsin" rules="" v-slot="{ errors }">
                                                <label class="form-label">Suivi Codir ASIN </label>
                                                <multi-select v-model="payload.suiviCodirAsin" deselect-label="Sélectionné" select-label="" :options="suiviCodirAsins"
                                                                placeholder="Sélectionné suivi codir asin" label="libelle" track-by="valeur" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <ValidationProvider name="approbationProjet" rules="" v-slot="{ errors }">
                                                <label class="form-label">Approbation Projet </label>
                                                <multi-select v-model="payload.approbationProjet" deselect-label="Sélectionné" select-label="" :options="approbations"
                                                                placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <ValidationProvider name="dateApprobation" rules="" v-slot="{ errors }">
                                                <label class="form-label">Date Approbation </label>
                                                <date-pick :language="fr" :bootstrapStyling="true" minimumView="day" name="dateApprobation"
                                                    v-model="payload.dateApprobation" placeholder="Sélectionnez la date d'approbation"
                                                    calendar-button-icon="fe fe-calendar" />
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="lotissement" rules="" v-slot="{ errors }">
                                                <label class="form-label">Lotissement </label>
                                                <multi-select v-model="payload.lotissement" deselect-label="Sélectionné" select-label="" :options="lotissements"
                                                                placeholder="Sélectionné lotissement" :searchable="true">
                                                    <template slot="option" slot-scope="{ option }">
                                                        <span>{{ option }}</span>
                                                    </template>
                                                    <template slot="singleLabel" slot-scope="{ option }">
                                                        <span>{{ option }}</span>
                                                    </template>
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="carteIdentite" rules="" v-slot="{ errors }">
                                                        <label class="form-label">Carte d'identité </label>
                                                        <multi-select v-model="payload.carteIdentite" deselect-label="Sélectionné" select-label=""  :options="carteIdentites"
                                                                        placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="fdrDispo" rules="" v-slot="{ errors }">
                                                        <label class="form-label">Feuille de route disponible </label>
                                                        <multi-select v-model="payload.fdrDispo" deselect-label="Sélectionné" select-label=""  :options="fdrDispos"
                                                                        placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="beneficiaire" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Bénéficiaire <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.beneficiaire" deselect-label="Sélectionné" select-label=""  :options="entites"
                                                                placeholder="Sélectionné le bénéficiaire" label="entNom" 
                                                                track-by="entCode" :searchable="true" :class="{ 'is-invalid': !payload.beneficiaire && soumissionTentée }">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="secteur_activite" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Secteur Activité Bénéficiaire <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.secteur_activite" deselect-label="Sélectionné" select-label=""  :options="secteurActivites"
                                                                placeholder="Sélectionné un secteur activité" label="libelle" track-by="secteur" 
                                                                :class="{ 'is-invalid': !payload.secteur_activite && soumissionTentée }" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="timesheetTypChant" rules="" v-slot="{ errors }">
                                                <label class="form-label">TimeSheet Type </label>
                                                <input type="text" name="timesheetTypChant" v-model="payload.timesheetTypChant" class="form-control" id="timesheetTypChant">
                                                <!-- <multi-select v-model="payload.timesheetTypChant" deselect-label="Sélectionné" select-label="" class="form-control" :options="degres"
                                                                placeholder="Sélectionné timesheet type" label="libelle" track-by="id" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select> -->
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div> 
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="timesheetResponsable" rules="" v-slot="{ errors }">
                                                <label class="form-label">TimeSheet Responsable </label>
                                                <multi-select v-model="payload.timesheetResponsable" deselect-label="Sélectionné" select-label=""  :options="timesheetResponsables"
                                                                placeholder="Sélectionné timesheet responsable" label="contact" track-by="idContact" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="expanel expanel-default">
                                        <div class="expanel-heading info02"><h3 class="expanel-title">Ressources ASIN & Référents</h3></div>
                                        <div class="expanel-body">
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="roleAsin" rules="required" v-slot="{ errors }">
                                                        <label class="form-label">Rôle ASIN <span class="text-danger">*</span></label>
                                                        <multi-select v-model="payload.roleAsin" deselect-label="Sélectionné" select-label=""  :options="rolesAsin"
                                                                        placeholder="Sélectionné" label="nomRole" track-by="idRole" 
                                                                        :class="{ 'is-invalid': !payload.roleAsin && soumissionTentée }" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="poleAsin" rules="required" v-slot="{ errors }">
                                                        <label class="form-label">Pole ASIN <span class="text-danger">*</span></label>
                                                        <multi-select v-model="payload.poleAsin" deselect-label="Sélectionné" select-label=""  :options="polesAsin"
                                                                        placeholder="Sélectionné" label="nomPole" track-by="idPole" 
                                                                        :class="{ 'is-invalid': !payload.poleAsin && soumissionTentée }" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                    <!-- <ValidationProvider name="cotechPresident" rules="" v-slot="{ errors }">
                                                        <label class="form-label">COTECH Président </label>
                                                        <multi-select v-model="payload.cotechPresident" deselect-label="Sélectionné" select-label=""  :options="cotechPresidents"
                                                                        placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider> -->
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="chefProjet" rules="required" v-slot="{ errors }">
                                                        <label class="form-label">Chef Projet ASIN <span class="text-danger">*</span></label>
                                                        <multi-select v-model="payload.chefProjet" deselect-label="Sélectionné" select-label=""  :options="chefProjets"
                                                                        placeholder="Sélectionné" label="contact" track-by="idContact" 
                                                                        :class="{ 'is-invalid': !payload.chefProjet && soumissionTentée }" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                    <!-- <ValidationProvider name="copilPresident" rules="" v-slot="{ errors }">
                                                        <label class="form-label">COPIL Président </label>
                                                        <multi-select v-model="payload.copilPresident" deselect-label="Sélectionné" select-label=""  :options="copilPresidents"
                                                                        placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider> -->
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="spmReferent" rules="" v-slot="{ errors }">
                                                        <label class="form-label">SPM Référent </label>
                                                        <multi-select v-model="payload.spmReferent" deselect-label="Sélectionné" select-label=""  :options="spmAsins"
                                                                        placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                    <!-- <ValidationProvider name="cojurPresident" rules="" v-slot="{ errors }">
                                                        <label class="form-label">COJUR Président </label>
                                                        <multi-select v-model="payload.cojurPresident" deselect-label="Sélectionné" select-label=""  :options="cojurPresidents"
                                                                        placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider> -->
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="pmoReferent" rules="required" v-slot="{ errors }">
                                                        <label class="form-label">PMO Référent <span class="text-danger">*</span></label>
                                                        <multi-select v-model="payload.pmoReferent" deselect-label="Sélectionné" select-label=""  :options="pmoAsins"
                                                                        placeholder="Sélectionné" label="contact" track-by="idContact" 
                                                                        :class="{ 'is-invalid': !payload.pmoReferent && soumissionTentée }" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <ValidationProvider name="dafReferent" rules="" v-slot="{ errors }">
                                                        <label class="form-label">DAF Référent </label>
                                                        <multi-select v-model="payload.dafReferent" deselect-label="Sélectionné" select-label=""  :options="dafAsins"
                                                                        placeholder="Sélectionné" label="contact" track-by="idContact" :searchable="true">
                                                            <span slot="noOptions">
                                                                <strong>Liste Vide</strong>
                                                            </span>
                                                            <span slot="noResult">
                                                                <strong>Aucun Résultat</strong>
                                                            </span>
                                                        </multi-select>
                                                        <small class="form-text text-danger">{{ errors[0] }}</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <ValidationProvider name="phaseExecution" rules="required" v-slot="{ errors }">
                                                <label class="form-label">Phase actuelle <span class="text-danger">*</span></label>
                                                <multi-select v-model="payload.phaseExecution" deselect-label="Sélectionné" select-label=""  :options="phaseExecutions"
                                                                placeholder="Sélectionné" label="nomPhase" 
                                                                :class="{ 'is-invalid': !payload.phaseExecution && soumissionTentée }" track-by="idPhase" :searchable="true">
                                                    <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                                                    <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                                                </multi-select>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="objectifSpecifique" rules="" v-slot="{ errors }">
                                                <label class="form-label">Objectif Spécifique </label>
                                                <textarea name="objectifSpecifique" v-model="payload.objectifSpecifique" class="form-control" id="objectifSpecifique" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="resultatSpecifique" rules="" v-slot="{ errors }">
                                                <label class="form-label">Résultat Spécifique </label>
                                                <textarea name="resultatSpecifique" v-model="payload.resultatSpecifique" class="form-control" id="resultatSpecifique" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset v-else-if="payload.currentStep === 3">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="alert alert-default">
                                                <ValidationProvider name="chargeTrAsinPrj" rules="required" v-slot="{ errors }">
                                                    <label class="form-label">
                                                        <span class="fw-bold">Charge de travail ASIN Projet (J/H) : </span> 
                                                        <span class="badge bg-success badge-sm me-1 mb-1 mt-1 fw-bold" style="font-size: 14px;">{{ payload.chargeTrAsinPrj ? payload.chargeTrAsinPrj : '0' }}</span>
                                                    </label>
                                                    <input type="hidden" name="chargeTrAsinPrj" v-model="payload.chargeTrAsinPrj" class="form-control" 
                                                    :class="{ 'is-invalid': !payload.chargeTrAsinPrj && soumissionTentée }" id="chargeTrAsinPrj">
                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="alert alert-default">
                                                <ValidationProvider name="chargeTrAsinRun" rules="" v-slot="{ errors }">
                                                    <label class="form-label">
                                                        <span class="fw-bold">Charge de travail ASIN RUN : </span> 
                                                        <span class="badge bg-success badge-sm me-1 mb-1 mt-1 fw-bold" style="font-size: 14px;">{{ payload.chargeTrAsinRun ? payload.chargeTrAsinRun : '0' }}</span>
                                                    </label>
                                                    <input type="hidden" name="chargeTrAsinRun" v-model="payload.chargeTrAsinRun" class="form-control" id="chargeTrAsinRun">
                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="form-row">
                                        <div class="col-md-4 mb-0">
                                            <table class="table table-hover table-bordered">
                                                <tr class="text-center info02">
                                                    <th><span class="fw-bold">Complexité : </span>
                                                        <span class="badge bg-success badge-sm me-1 mb-1 mt-1 fw-bold" style="font-size: 14px;">{{ payload.complexiteMiseEnOeuvre ? payload.complexiteMiseEnOeuvre : 'Non renseigné' }}</span></th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="form-row">
                                                            <div class="form-group col-md-12">
                                                                <ValidationProvider name="complexiteSolution" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">De la solution </label>
                                                                    <multi-select v-model="payload.complexiteSolution" deselect-label="Sélectionné" select-label=""  :options="complexiteSolutions"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyComplexite(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="form-group col-md-12">
                                                                <ValidationProvider name="complexiteMGouv" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Mise en oeuvre gouvernance </label>
                                                                    <multi-select v-model="payload.complexiteMGouv" deselect-label="Sélectionné" select-label=""  :options="complexiteMGouvs"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyComplexite(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="form-group col-md-12">
                                                                <ValidationProvider name="complexiteMDispo" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Mise à Dispo des Prérequis </label>
                                                                    <multi-select v-model="payload.complexiteMDispo" deselect-label="Sélectionné" select-label=""  :options="complexiteMDispos"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyComplexite(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="form-group col-md-12">
                                                                <ValidationProvider name="complexiteMco" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">MCO </label>
                                                                    <multi-select v-model="payload.complexiteMco" deselect-label="Sélectionné" select-label=""  :options="complexiteMcos"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyComplexite(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-md-8 mb-0">
                                            <table class="table table-hover table-bordered">
                                                <tr class="text-center info02">
                                                    <th><span class="fw-bold">Intérêt / Impact : </span>
                                                        <span class="badge bg-success badge-sm me-1 mb-1 mt-1 fw-bold" style="font-size: 14px;">{{ payload.interetImpact ? payload.interetImpact : 'Non renseigné' }}</span></th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="form-row">
                                                            <div class="form-group col-md-6">
                                                                <ValidationProvider name="interetMetier" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Intérêt Métier ou Besoin </label>
                                                                    <multi-select v-model="payload.interetMetier" deselect-label="Sélectionné" select-label="" :options="interetMetierBens"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyInteretImpact(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                            <div class="form-group col-md-6">
                                                                <ValidationProvider name="impactEnvSoc" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Impact Environnemental Social </label>
                                                                    <multi-select v-model="payload.impactEnvSoc" deselect-label="Sélectionné" select-label=""  :options="impactEnvSocs"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyInteretImpact(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="form-group col-md-6">
                                                                <ValidationProvider name="interetStrategique" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Intérêt Stratégique </label>
                                                                    <multi-select v-model="payload.interetStrategique" deselect-label="Sélectionné" select-label=""  :options="interetStrategiques"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyInteretImpact(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                            <div class="form-group col-md-6">
                                                                <ValidationProvider name="impactJuridique" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Impact Juridique de l'implémentation </label>
                                                                    <multi-select v-model="payload.impactJuridique" deselect-label="Sélectionné" select-label=""  :options="impactJuridiques"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyInteretImpact(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="form-group col-md-6">
                                                                <ValidationProvider name="interetEconomique" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Intérêt Economique </label>
                                                                    <multi-select v-model="payload.interetEconomique" deselect-label="Sélectionné" select-label=""  :options="interetEconomiques"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyInteretImpact(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                            <div class="form-group col-md-6">
                                                                <ValidationProvider name="interetPolitique" rules="" v-slot="{ errors }">
                                                                    <label class="form-label">Intérêt Politique </label>
                                                                    <multi-select v-model="payload.interetPolitique" deselect-label="Sélectionné" select-label=""  :options="interetPolitiques"
                                                                                    placeholder="Sélectionné" label="libelle" track-by="valeur" :searchable="true"
                                                                                    @select="verifyInteretImpact(payload)">
                                                                        <span slot="noOptions">
                                                                            <strong>Liste Vide</strong>
                                                                        </span>
                                                                        <span slot="noResult">
                                                                            <strong>Aucun Résultat</strong>
                                                                        </span>
                                                                    </multi-select>
                                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                                </ValidationProvider>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset v-else-if="payload.currentStep === 4">
                                    <h5 class="text-muted fw-bold mb-4 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="faisabilitePtf" rules="" v-slot="{ errors }">
                                                <label class="form-label">Faisabilité PTF </label>
                                                <textarea name="faisabilitePtf" v-model="payload.faisabilitePtf" class="form-control" id="faisabilitePtf" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="faisabilitePpp" rules="" v-slot="{ errors }">
                                                <label class="form-label">Faisabilité PPP </label>
                                                <textarea name="faisabilitePpp" v-model="payload.faisabilitePpp" class="form-control" id="faisabilitePpp" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="ptfPressentis" rules="" v-slot="{ errors }">
                                                <label class="form-label">PTF Préssentis </label>
                                                <textarea name="ptfPressentis" v-model="payload.ptfPressentis" class="form-control" id="ptfPressentis" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="faisabiliteJv" rules="" v-slot="{ errors }">
                                                <label class="form-label">Faisabilité JV </label>
                                                <textarea name="faisabiliteJv" v-model="payload.faisabiliteJv" class="form-control" id="faisabiliteJv" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="commentairesFinance" rules="" v-slot="{ errors }">
                                                <label class="form-label">Commentaires Financement </label>
                                                <textarea name="commentairesFinance" v-model="payload.commentairesFinance" class="form-control" id="commentairesFinance" ></textarea>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-md-6 mb-0">
                                            <ValidationProvider name="odd" rules="" v-slot="{ errors }">
                                                <label class="form-label">ODD ? </label>
                                                <label class="custom-switch form-switch me-3">
                                                        <input type="radio" name="odd" class="custom-switch-input" checked value="Non" v-model="payload.odd">
                                                        <span class="custom-switch-indicator"></span>
                                                        <span class="custom-switch-description">Non</span>
                                                    </label>
                                                    <label class="custom-switch form-switch">
                                                        <input type="radio" name="odd" class="custom-switch-input" value="Oui" v-model="payload.odd">
                                                        <span class="custom-switch-indicator"></span>
                                                        <span class="custom-switch-description">Oui</span>
                                                    </label>
                                                <small class="form-text text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <table class="table table-hover table-bordered">
                                                <tr class="info02">
                                                    <th colspan="2" class="text-center">Niveau Exécution Planifiée</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-center">Année</th>
                                                    <th class="text-center">Taux (%)</th>
                                                </tr>
                                                <tr v-for="(item, index) in exercices" :key="index">
                                                    <td>{{ item?.annee }}</td>
                                                    <td><input type="number" class="form-control taux" v-model="payload.planificationList[index].tepPlanifie" @input="calculTaux()"></td>
                                                </tr>
                                                <tr>
                                                    <td class="text-end fw-semibold">Total Taux</td>
                                                    <td><input type="number" name="tepPlanifie" v-model="payload.tepPlanifie" class="form-control" id="tepPlanifie" readonly>
                                                        <small class="form-text text-danger" id="tauxError"></small></td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <table class="table table-hover table-bordered">
                                                <tr class="info02">
                                                    <th colspan="2" class="text-center">CAPEX Estimé</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-center">Année</th>
                                                    <th class="text-center">Montant</th>
                                                </tr>
                                                <tr v-for="(item, index) in exercices" :key="index">
                                                    <td>{{ item?.annee }}</td>
                                                    <td><input type="number" class="form-control montantCapex" v-model="payload.planificationList[index].capexEstime" @input="calculAmountCapex()" value="0"></td>
                                                </tr>
                                                <tr>
                                                    <td class="text-end fw-semibold">Total CAPEX</td>
                                                    <td><input type="number" name="capex" v-model="payload.capex" class="form-control" id="capex" readonly>
                                                    <small class="form-text text-danger" id="capexError"></small></td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <table class="table table-hover table-bordered">
                                                <tr class="info02">
                                                    <th colspan="2" class="text-center">OPEX Estimé</th>
                                                </tr>
                                                <tr>
                                                    <th class="text-center">Année</th>
                                                    <th class="text-center">Montant</th>
                                                </tr>
                                                <tr v-for="(item, index) in exercices" :key="index">
                                                    <td>{{ item?.annee }}</td>
                                                    <td><input type="number" class="form-control montantOpex" v-model="payload.planificationList[index].opexEstime" @input="calculAmountOpex()" value="0"></td>
                                                </tr>
                                                <tr>
                                                    <td class="text-end fw-semibold">Total OPEX</td>
                                                    <td><input type="number" name="opex" v-model="payload.opex" class="form-control" id="opex" readonly>
                                                    <small class="form-text text-danger" id="opexError"></small></td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset v-else-if="payload.currentStep === 5">
                                    <h5 class="text-muted fw-bold mb-5 text-center text-uppercase" style="font-size: 20px">{{ activeStep }}</h5>
                                    <div class="table-responsive">
                                        <div v-for="(stepFields, index) in groupedFields" :key="index" class="mb-4">
                                            <table class="table table-hover table-bordered">
                                                <thead>
                                                    <tr class="success02 text-center">
                                                        <th colspan="2" class="fw-bold">Étape {{ index + 1 }}</th>
                                                    </tr>
                                                    <tr class="info02">
                                                        <th class="fw-bold">Champ</th>
                                                        <th class="fw-bold">Valeur</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="field in stepFields" :key="field.key" :class="{'table-danger': isEmpty(field.value)}">
                                                        <td class="fw-bold">{{ field.label }}</td>
                                                        <td>
                                                            <span v-if="typeof field.value == 'object' && field.value != null">
                                                            {{ field.value.libelle || field.value.nomClasseur || field.value.p4wComposanteSubject || field.value.nomProjetPag || field.value.nomSsProjPag || field.value.nomProgram || field.value.entNom || field.value.nomPhase || field.value.nomRole || field.value.nomPole || field.value.contact || '[Objet]' }}
                                                            </span>
                                                            <span v-else>
                                                            {{ field.value || '[Non renseigné]' }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </fieldset>
                                <div class="alert alert-success mt-3" v-if="true">
                                    <small>
                                        Etape : {{ payload.currentStep }} / {{ steps.length }} | 
                                        Dernière : {{ isLastStep ? 'OUI' : 'NON' }} | 
                                        Actif : {{ activeStep }}
                                    </small>
                                </div>
                                <div class="form-group d-flex justify-content-between mt-5">
                                    <button type="button" class="style_btn btn btn-outline-dark rounded-0" @click.prevent="sentBack" id="previous">
                                        {{ payload.currentStep === 1 ? 'Fermer' : 'Précédent' }}
                                    </button>
                                    <button type="button" class="style_btn btn btn-outline-info rounded-0" id="saveTemp" @click.prevent="submitPartial">
                                        {{ 'Sauvegarder' }}
                                    </button>
                                    <button type="submit" class="style_btn float-right btn btn-outline-success rounded-0" id="next">
                                        {{ isLastStep ? 'Terminer' : 'Suivant' }}
                                    </button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
import { reduce } from "lodash";

const customLabels = {
  first: '<<',
  last: '>>',
  previous: '<',
  next: '>'
};

export default {
    name: "Composantes",
    data() {
        return {
            lang: lang, payload:{currentStep: 1, idClasseur: {}, idComposante: '', nomComposante: '', etatComposante: {etat: 'INACTIF', libelle: 'Inactif'},
            idProjetPag: {}, statut: {statut: '00', libelle: '00 - A planifier'}, idSsProjPag: {}, tepGlobal: 0, idAction: {}, idPilier: {idPilier: 'A confirmer', nomPilier: 'A confirmer'},
            degreConfidentialite: {degre: '2', libelle: 'Confidentiel'}, descriptionEnjeux: '', projetsTributaires: '', descriptionExistantBesoin: '',
            prerequis: '', descriptionScenImpl: '', idProjetRefSectoriel: '', analyseJustif: '', priorite: {priorite: 'P1', libelle: 'P1 - Moyen'},
            suiviCodirAsin: {valeur: 'Aconfir', libelle: 'A confirmer'}, approbationProjet: {valeur: 'Aconfir', libelle: 'A confirmer'}, dateApprobation: '', lotissement: 'A_CONFIRMER', beneficiaire: {entCode: 'A confirmer', entNom: 'A confirmer'},
            secteur_activite: {secteur: 1, libelle: '+'}, timesheetTypChant: '', timesheetResponsable: {idContact: 'A confirmer', contact: 'A confirmer'}, complexiteSolution: {valeur: '2', libelle: 'Moyen'}, complexiteMGouv: {valeur: '2', libelle: 'Moyen'},
            complexiteMDispo: {valeur: '2', libelle: 'Moyen'}, complexiteMco: {valeur: '2', libelle: 'Moyen'}, interetMetier: {valeur: '2', libelle: 'Moyen'}, impactEnvSoc: {valeur: '2', libelle: 'Moyen'}, interetStrategique: {valeur: '2', libelle: 'Moyen'},
            impactJuridique: {valeur: '2', libelle: 'Moyen'}, interetEconomique: {valeur: '2', libelle: 'Moyen'}, interetPolitique: {valeur: '2', libelle: 'Moyen'}, phaseExecution: {idPhase: 'A-conf', nomPhase: 'A confirmer'},
            fdrDispo: {valeur: 'Aconfir', libelle: 'A confirmer'}, roleAsin: {idRole: 'A confirmer', nomRole: 'A confirmer'}, cotechPresident: {idContact: 'A confirmer', contact: 'A confirmer'}, poleAsin: {idPole: 'A confirmer', nomPole: 'A confirmer'}, 
            copilPresident: {idContact: 'A confirmer', contact: 'A confirmer'}, chefProjet: {idContact: 'A confirmer', contact: 'A confirmer'},
            cojurPresident: {idContact: 'A confirmer', contact: 'A confirmer'}, spmReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, pmoReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, dafReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, faisabilitePtf: '', faisabilitePpp: '',
            dateDebutPlanifiee: '', ptfPressentis: '', faisabiliteJv: '', dateFinPlanifiee: '', commentairesFinance: '',
            odd: 'Oui', chargeTrAsinPrj: '0', chargeTrAsinRun: '0', capex: 0, opex: 0, idProgram: {idProgram: 'DOC', nomProgram: 'Ingénierie documentaire'}, carteIdentite: {valeur: 'Aconfir', libelle: 'A confirmer'}, tauxFinancement: 0,
            idMeteo:'', idGouvernance: {id: 1,}, nbMarchesLances: 0, nbMarchesPass: 0, nbMarchesNotif: 0, nbMarchesExec: 0, nbMarchesRecep:0, retardFdr: 'Non',
            urlP4w: '', urlSharepoint: '', p4wTaskCreated: 0, p4wComposanteGuid: {p4wComposanteGuid: 'A Confirmer', p4wComposanteSubject: 'A Confirmer'}, 
            planificationList: [], interetImpact: '', objectifStrategique: '', detailProgrammeStrategique: '', objectifSpecifique: '', resultatSpecifique: '',  complexiteMiseEnOeuvre: '', tepPlanifie: 0,
            },
            composanteP4wDisponible: {p4wComposanteGuid: 'A Confirmer', p4wComposanteSubject: 'A Confirmer'},
            save: true, showList: true, notModified: false, soumissionTentée: false,
            degres: [], classeur: {}, lesComposantes: [], idC: '', totalTepPlanifie: 0, totalCapexEstime: 0, totalOpexEstime: 0,
            steps: [
            'Composante | Informations générales', 'Qualification', 'Complexité & Intérêt/Impact', 'Planification', 'Récapitulatif'
            ], classeurs: [], etatComposantes: [], statutComposantes: [], projetsPag: [], sousProjetsPag: [], pillierPlStrats: [], priorites: [],
            secteurActivites: [], timesheetTypes: [], timesheetResponsables: [], phaseExecution: [], rolesAsin: [], polesAsin: [], copilAsins: [],
            cojurAsins: [], spmAsins: [], pmoAsins: [], dafAsins: [], exercices: [], impactEnvSocs: [], impactJuridiques: [],
            interetEconomiques: [], interetMetierBens: [], interetPolitiques: [], interetStrategiques: [], programmeStrats: [], complexiteSolutions: [],
            complexiteMcos: [], complexiteMGouvs: [], complexiteMDispos: [], beneficiaires: [], entites: [], carteIdentites: [],
            fdrDispos: [], cotechPresidents: [], copilPresidents: [], cojurPresidents: [], odds: [], p4wComposanteGuids: [], actionsPag: [],
            composante: {}, montantsCapex: {}, montantsOpex: {}, niveauxTaux: {}, planifications: [], planificationsModifier: [], suiviCodirAsins: [], chefProjets: [], approbations: [],
            lotissements: [], composantesP4wDisponibles: [],
            currentPage: 1,
            perPage: 10,
            currentSort: 'declaredAt',
            currentSortDir: 'asc', customLabels,
            columns: [],
            reinit: false,
            page: { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
            showFilter: false,
            tagsClasseurs: [], meteos: [],
        }
    },
    computed: {
        ...mapGetters({ items: 'composantes/list' }),
        filtersItems() {
            // const start = (this.currentPage - 1) * this.perPage;
            // return this.sortedItems.slice(start, start + this.perPage);
            if (this.classeur.idClasseur == undefined) {
                console.log('PAR DEFAUT');
                this.lesComposantes = this.items?.content || [];
            } else {
                console.log('IL Y A UN CLASSEUR');
                this.lesComposantes = this.lesComposantes;
            }
            return this.lesComposantes || [];
        },
        fr() {
          return this.lang.fr;
        },
        activeStep() {
            return this.steps[this.payload.currentStep - 1] || `Étape ${this.payload.currentStep}`;
        },
        isLastStep() {
            return this.payload.currentStep >= this.steps.length;
        },
        groupedFields() {
            return [
                // Étape 1
                [
                    { key: 'idClasseur', label: 'Classeur', value: this.payload.idClasseur },
                    { key: 'p4wComposanteGuid', label: 'Project 4 The Web Composante', value: this.payload.p4wComposanteGuid },
                    { key: 'idComposante', label: 'ID Composante', value: this.payload.idComposante },
                    { key: 'nomComposante', label: 'Nom Composante', value: this.payload.nomComposante },
                    { key: 'etatComposante', label: "État ou implication ASIN", value: this.payload.etatComposante },
                    { key: 'idProjetPag', label: 'Projet PAG', value: this.payload.idProjetPag },
                    { key: 'statut', label: 'Statut', value: this.payload.statut },
                    { key: 'idSsProjPag', label: 'Sous projet PAG', value: this.payload.idSsProjPag },
                    { key: 'tepGlobal', label: 'TEP Global (%)', value: this.payload.tepGlobal },
                    { key: 'idAction', label: 'Action PAG', value: this.payload.idAction },
                    { key: 'idProgram', label: 'Programme Stratégique', value: this.payload.idProgram },
                    { key: 'urlP4w', label: 'Lien Project 4 The Web', value: this.payload.urlP4w },
                    { key: 'urlSharepoint', label: 'Lien SharePoint', value: this.payload.urlSharepoint },
                    { key: 'retardFdr', label: 'Retard Feuille de Route', value: this.payload.retardFdr },
                    { key: 'dateDebutPlanifiee', label: 'Date début planifiée', value: this.payload.dateDebutPlanifiee },
                    { key: 'dateFinPlanifiee', label: 'Date fin planifiée', value: this.payload.dateFinPlanifiee },
                    { key: 'chargeTrAsinPrj', label: 'Charge travail ASIN projet', value: this.payload.chargeTrAsinPrj },
                ],
                // Étape 2
                [
                    { key: 'degreConfidentialite', label: 'Degré de confidentialité', value: this.payload.degreConfidentialite },
                    { key: 'descriptionEnjeux', label: 'Description Enjeux', value: this.payload.descriptionEnjeux },
                    { key: 'projetsTributaires', label: 'Projets tributaires', value: this.payload.projetsTributaires },
                    { key: 'descriptionExistantBesoin', label: 'Description Besoin Existant', value: this.payload.descriptionExistantBesoin },
                    { key: 'prerequis', label: 'Prérequis', value: this.payload.prerequis },
                    { key: 'descriptionScenImpl', label: 'Description Scénario d’implémentation', value: this.payload.descriptionScenImpl },
                    { key: 'idProjetRefSectoriel', label: 'ID Projet Secteuriel', value: this.payload.idProjetRefSectoriel },
                    { key: 'analyseJustif', label: 'Analyse et Justification', value: this.payload.analyseJustif },
                    { key: 'priorite', label: 'Priorité', value: this.payload.priorite },
                    { key: 'suiviCodirAsin', label: 'Suivi CODIR', value: this.payload.suiviCodirAsin },
                    { key: 'approbationProjet', label: 'Approbation Projet', value: this.payload.approbationProjet },
                    { key: 'dateApprobation', label: 'Date d’approbation', value: this.payload.dateApprobation },
                    { key: 'lotissement', label: 'Lotissement', value: this.payload.lotissement },
                    { key: 'beneficiaire', label: 'Bénéficiaire', value: this.payload.beneficiaire },
                    { key: 'secteur_activite', label: 'Secteur d’activité', value: this.payload.secteur_activite },
                    { key: 'timesheetTypChant', label: 'Timesheet Type de chantier', value: this.payload.timesheetTypChant },
                    { key: 'timesheetResponsable', label: 'Timesheet Responsable', value: this.payload.timesheetResponsable },
                    { key: 'carteIdentite', label: 'Carte d\'identité', value: this.payload.carteIdentite },
                    { key: 'phaseExecution', label: 'Phase actuelle', value: this.payload.phaseExecution },
                    { key: 'fdrDispo', label: 'Feuille de route disponible', value: this.payload.fdrDispo },
                    { key: 'roleAsin', label: 'Role ASIN', value: this.payload.roleAsin },
                    { key: 'cotechPresident', label: 'Cotech President', value: this.payload.cotechPresident },
                    { key: 'poleAsin', label: 'Pole ASIN', value: this.payload.poleAsin },
                    { key: 'copilPresident', label: 'Copil President', value: this.payload.copilPresident },
                    { key: 'chefProjet', label: 'Chef Projet', value: this.payload.chefProjet },
                    { key: 'cojurPresident', label: 'Cojur President', value: this.payload.cojurPresident },
                    { key: 'spmReferent', label: 'SPM Référent', value: this.payload.spmReferent },
                    { key: 'pmoReferent', label: 'PMO Référent', value: this.payload.pmoReferent },
                    { key: 'dafReferent', label: 'DAF Référent', value: this.payload.dafReferent },
                ],
                // Étape 3
                [
                    { key: 'complexiteSolution', label: 'Complexité de la solution', value: this.payload.complexiteSolution },
                    { key: 'complexiteMGouv', label: 'Complexité M-GOUV', value: this.payload.complexiteMGouv },
                    { key: 'complexiteMDispo', label: 'Complexité M-DISPO', value: this.payload.complexiteMDispo },
                    { key: 'complexiteMco', label: 'Complexité MCO', value: this.payload.complexiteMco },
                    { key: 'interetMetier', label: 'Intérêts metiers', value: this.payload.interetMetier },
                    { key: 'impactEnvSoc', label: 'Impact environnement social', value: this.payload.impactEnvSoc },
                    { key: 'interetStrategique', label: 'Intérêt stratégique', value: this.payload.interetStrategique },
                    { key: 'impactJuridique', label: 'Impact juridique', value: this.payload.impactJuridique },
                    { key: 'interetEconomique', label: 'Intérêt économique', value: this.payload.interetEconomique },
                    { key: 'interetPolitique', label: 'Intérêt politique', value: this.payload.interetPolitique },
                ],
                // Étape 4
                [
                    { key: 'faisabilitePtf', label: 'Faisabilité PTF', value: this.payload.faisabilitePtf },
                    { key: 'faisabilitePpp', label: 'Faisabilité PPP', value: this.payload.faisabilitePpp },
                    { key: 'ptfPressentis', label: 'PTF Pressentis', value: this.payload.ptfPressentis },
                    { key: 'faisabiliteJv', label: 'Faisabilité JV', value: this.payload.faisabiliteJv },
                    { key: 'commentairesFinance', label: 'Commentaires financement', value: this.payload.commentairesFinance },
                    { key: 'odd', label: 'ODD', value: this.payload.odd },
                    { key: 'chargeTrAsinRun', label: 'Charge travail ASIN RUN', value: this.payload.chargeTrAsinRun },
                    { key: 'capex', label: 'COPEX', value: this.payload.capex },
                    { key: 'opex', label: 'OPEX', value: this.payload.opex },
                ]
            ];
        },
        pageCount() {
            return Math.ceil(this.items.length / this.perPage);
        },        
        filters() {
            return this.columns.filter(o => o.used);
        },
        option() {
            return reduce(this.filters, (acc, item) => (acc[item.name] = item.value, acc), {})
        },
        sortedItems() {
            return this.meteos.sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                if (this.currentSortDir === 'asc') {
                return aVal > bVal ? 1 : -1;
                } else {
                return aVal < bVal ? 1 : -1;
                }
            });
        },
        filtersItemsMeteos(){
            const start = (this.currentPage - 1) * this.perPage;
            return this.sortedItems.slice(start, start + this.perPage);
        },
        pageCountMeteo() {
            return Math.ceil(this.meteos.length / this.perPage);
        },
    },
    watch: {
        page: {
            deep: true,
            immediate: true,
            handler(value) {
                this.reinit = true;
                this.onSearch();
            }
        }
    },
    mounted() {
        const classeur = this.$route.params.idClasseur;
        const showList = this.$route.params.showList;
        if(showList != undefined) this.showList = showList;
        else this.showList = true;
        if(classeur) this.payload.idClasseur = this.$route.params.idClasseur;
    },
    methods: {
        ...mapActions('composantes', ['allPage', 'add']),
        updateActiveStepTitle() {
            this.activeStep = this.steps[this.payload.currentStep - 1] || `Étape ${this.payload.currentStep}`;
        },
        initPayload(){
            return this.payload = {currentStep: 1, idClasseur: {}, idComposante: '', nomComposante: '', etatComposante: {etat: 'INACTIF', libelle: 'Inactif'},
            idProjetPag: {}, statut: {statut: '00', libelle: '00 - A planifier'}, idSsProjPag: {}, tepGlobal: 0, idAction: {}, idPilier: {idPilier: 'A confirmer', nomPilier: 'A confirmer'},
            degreConfidentialite: {degre: '2', libelle: 'Confidentiel'}, descriptionEnjeux: '', projetsTributaires: '', descriptionExistantBesoin: '',
            prerequis: '', descriptionScenImpl: '', idProjetRefSectoriel: '', analyseJustif: '', priorite: {priorite: 'P1', libelle: 'P1 - Moyen'},
            suiviCodirAsin: {valeur: 'Aconfir', libelle: 'A confirmer'}, approbationProjet: {valeur: 'Aconfir', libelle: 'A confirmer'}, dateApprobation: '', lotissement: 'A_CONFIRMER', beneficiaire: {entCode: 'A confirmer', entNom: 'A confirmer'},
            secteur_activite: {secteur: 1, libelle: '+'}, timesheetTypChant: '', timesheetResponsable: {idContact: 'A confirmer', contact: 'A confirmer'}, complexiteSolution: {valeur: '2', libelle: 'Moyen'}, complexiteMGouv: {valeur: '2', libelle: 'Moyen'},
            complexiteMDispo: {valeur: '2', libelle: 'Moyen'}, complexiteMco: {valeur: '2', libelle: 'Moyen'}, interetMetier: {valeur: '2', libelle: 'Moyen'}, impactEnvSoc: {valeur: '2', libelle: 'Moyen'}, interetStrategique: {valeur: '2', libelle: 'Moyen'},
            impactJuridique: {valeur: '2', libelle: 'Moyen'}, interetEconomique: {valeur: '2', libelle: 'Moyen'}, interetPolitique: {valeur: '2', libelle: 'Moyen'}, phaseExecution: {idPhase: 'A-conf', nomPhase: 'A confirmer'},
            fdrDispo: {valeur: 'Aconfir', libelle: 'A confirmer'}, roleAsin: {idRole: 'A confirmer', nomRole: 'A confirmer'}, cotechPresident: {idContact: 'A confirmer', contact: 'A confirmer'}, poleAsin: {idPole: 'A confirmer', nomPole: 'A confirmer'}, 
            copilPresident: {idContact: 'A confirmer', contact: 'A confirmer'}, chefProjet: {idContact: 'A confirmer', contact: 'A confirmer'},
            cojurPresident: {idContact: 'A confirmer', contact: 'A confirmer'}, spmReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, pmoReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, dafReferent: {idContact: 'A confirmer', contact: 'A confirmer'}, faisabilitePtf: '', faisabilitePpp: '',
            dateDebutPlanifiee: '', ptfPressentis: '', faisabiliteJv: '', dateFinPlanifiee: '', commentairesFinance: '',
            odd: 'Oui', chargeTrAsinPrj: '0', chargeTrAsinRun: '', capex: 0, opex: 0, idProgram: {idProgram: 'DOC', nomProgram: 'Ingénierie documentaire'}, carteIdentite: {valeur: 'Aconfir', libelle: 'A confirmer'}, tauxFinancement: 0,
            idMeteo:'', idGouvernance: {id: 1,}, nbMarchesLances: 0, nbMarchesPass: 0, nbMarchesNotif: 0, nbMarchesExec: 0, nbMarchesRecep:0, retardFdr: 'Non',
            urlP4w: '', urlSharepoint: '', p4wTaskCreated: 0, p4wComposanteGuid: {p4wComposanteGuid: 'A Confirmer', p4wComposanteSubject: 'A Confirmer'}, 
            planificationList: [], interetImpact: '', objectifStrategique: '', detailProgrammeStrategique: '', objectifSpecifique: '', resultatSpecifique: '',  complexiteMiseEnOeuvre: '', tepPlanifie: 0,
            };
        },
        champsObligatoiresValides() {
            const p = this.payload;

            const champsInvalides = [
            !p.idClasseur,
            !p.nomComposante,
            !p.statut,
            !p.etatComposante,
            !p.idSsProjPag,
            !p.priorite,
            !p.beneficiaire,
            !p.secteur_activite,
            !p.phaseExecution,
            !p.roleAsin,
            !p.poleAsin,
            !p.chefProjet,
            !p.pmoReferent,
            !p.dateDebutPlanifiee,
            !p.dateFinPlanifiee,
            !p.chargeTrAsinPrj
            ];

            return !champsInvalides.includes(true);
        },
        buildColumns(){
            this.columns = [
                { name: 'couleur', description: 'Météo (couleur)', used: false,
                    options: [
                        {key: 'Blanc', value: 'Blanc'},
                        {key: 'Vert', value: 'Vert'},
                        {key: 'Orange', value: 'Orange'},
                        {key: 'Rouge', value: 'Rouge'},
                        {key: 'Bleu', value: 'Bleu'},
                        {key: 'Noir', value: 'Noir'},
                    ]
                 },
            ];
        },
        formatDate(value) {
            if (!value) return '';
            return moment(value).format('DD-MM-YYYY'); // ou 'DD-MM-YYYY HH:mm' si besoin
        },
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            return typeof val === 'string' ? val.toLowerCase() : val;
        },
        isEmpty(value) {
            return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            if (this.reinit) {
                this.option.page = 0;
                this.reinit = false;
            }
            if (this.page) this.option.size = this.page.value
            //this.$router.push({ query: this.option }).catch(() => { });
            //this.$store.dispatch('composantes/all', this.option).finally(() => this.$loading(false));
            this.allPage(this.option).finally(() => this.$loading(false));
        },
        onSearchBack(item) {
            item.used = false;
            this.onSearch();
        },
        sentBack() {
            if (this.payload.currentStep === 1) {
                this.showList = true;
                this.onSearch();
                this.initPayload();
            } else {
                this.payload.currentStep--;
            }
        },
        onNextep() {
            if (this.payload.currentStep === 1) {
                if (!this.payload.idClasseur) {
                    return swal('Information!', 'Le classeur est requis.', 'warning');
                }
                if (!this.payload.nomComposante || this.payload.nomComposante.trim() === '') {
                    return swal('Information!', 'Le nom de la composante est requis.', 'warning');
                }
                if (!this.payload.etatComposante) {
                    return swal('Information!', 'Le nom de la composante est requis.', 'warning');
                }
                this.payload.currentStep++;
                this.updateActiveStepTitle();
            } else {
                if (this.isLastStep){
                    return this.submit();
                } else if(this.payload.currentStep === 4){
                    var totalCapex = this.payload.capex;
                    var totalOpex = this.payload.opex;
                    console.log(totalCapex, totalOpex);
                    if(parseInt(totalCapex) != parseInt(totalOpex)) 
                        return swal('Information!', 'Le total capex et opex doivent avoir la même valeur.', 'warning');
                    else if(parseInt(this.payload.capex) < 0)
                        return swal('Information!', 'Le total capex doit avoir une valeur positive.', 'warning');
                    else if(parseInt(this.payload.opex) < 0)
                        return swal('Information!', 'Le total opex doit avoir une valeur positive.', 'warning');
                    else if(parseInt(this.payload.tepPlanifie) < 0 || parseInt(this.payload.tepPlanifie) > 100)
                        return swal('Information!', 'Le TEP planifié doit avoir une valeur comprise entre 0 et 100.', 'warning');
                    else if(this.payload.dateDebutPlanifiee === '' || this.payload.dateFinPlanifiee === '')
                        return swal('Information!', 'La date de debut et la date de fin planifiée doivent être renseignée.', 'warning');
                    else{
                        this.payload.currentStep++;
                        this.updateActiveStepTitle();
                    }
                }else{
                    this.payload.currentStep++;
                    this.updateActiveStepTitle();
                }
            }
            console.log('Nouvelle étape : ', this.payload.currentStep);
        },
        showForm() {
            this.showList = false;
            this.save = true;
        },
        showClasseurs() {
            this.$router.push({ name: 'classeurs' });  
        },
        showMeteos() {
            this.$router.push({ name: 'meteos' });
        },
        showValidationMeteo(){
            this.$router.push({ name: 'validationMeteos'});
        },
        showAssignationComposantesP4W(){
            this.$router.push({ name: 'assignationComposantesP4W'});
        },
        sentBackPortefeuille() {
            this.$router.push({ name: 'composantes', params: { showList: true }});
        },
        edit(value){
            this.$loading(true);
            this.save = false;
            console.log(value);
            this.payload = {
                ...value,
                idProjetPag: value?.idSsProjPag?.idProjetPag,
                idAction: value?.idSsProjPag?.idProjetPag?.idAction,
                currentStep: 1
            };
            var startYear = new Date(this.payload.dateDebutPlanifiee).getFullYear();
            var endYear = new Date(this.payload.dateFinPlanifiee).getFullYear();
            this.$http.get(`/exercice/filter/${startYear}/${endYear}`)
            .then(({data}) =>{
                this.$loading(true);
                $('#saveTemp').prop('disabled', true);
                $('#next').prop('disabled', true);
                this.exercices = [];
                this.exercices = data;
                this.$http.get('/planification/composante/' + value.idComposante)
                .then(({data}) =>{
                    this.payload.planificationList = data;
                    //console.log('PlanificationList:', JSON.stringify(this.payload.planificationList));
                    this.exercices.forEach((item, index) => {
                        const annee = item.annee;
                        const existant = this.payload.planificationList.find(p => p.annee.annee == annee);
                        if(!existant){
                            this.payload.planificationList.push({annee: item, tepPlanifie: 0, capexEstime: 0, opexEstime: 0});
                        }
                    });
                    console.log(this.payload.planificationList);
                })
                .catch((error) => {
                    swal('Information!', 'Erreur lors du chargement des planifications : ' + error, 'error');
                    console.error('Erreur lors du chargement des planifications :', error);
                })
                .finally(() => this.$loading(false));
                $('#saveTemp').prop('disabled', false);
                $('#next').prop('disabled', false);
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors de la récupération des exercices : ' + error, 'error');
            })
            .finally(() => this.$loading(false));
            this.showList = false;
            this.$nextTick(() => {
                console.log('After edit - Current step:', this.payload.currentStep);
                console.log('After edit - Is last step:', this.isLastStep);
                console.log('After edit - Active step:', this.activeStep);
            });
            this.$loading(false);
        },
        submit(){
            const self = this;
            self.payload.initTermine = 1;
            if (self.payload.idComposante === '') {
                swal({
                    title: "Confirmation",
                    text: "Etes-vous sûr de vouloir enregistrer la composante ?",
                    type: "warning",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    cancelButtonText: "Annuler",
                    confirmButtonText: "Enregistrer",
                    confirmButtonColor: "#7db0b2",
                    cancelButtonColor: "#FF0000",
                    showLoaderOnConfirm: true
                }, function(result) {
                    if (result === true) {
                        self.$loading(true);
                        self.$http.get('/composantes/generer/' + self.payload.idClasseur.idClasseur)
                        .then(({data}) =>{
                            self.$loading(true);
                            self.idC = data.idComposante;
                            self.payload.idComposante = self.idC;
                            self.$http.post('/composantes', self.payload)
                            .then(({data}) => {
                                    // self.$swal.fire('Information', 'Classeur enregistré avec succès.', 'success').then(() => {
                                    //     self.payload = {nom: ""};
                                    // });
                                if(data){
                                    swal('Information!', 'Composante enregistrée avec succès.', 'success');
                                    self.initPayload();
                                    self.onSearch();
                                    self.showList = true;
                                }else {
                                    swal('Information!', 'L\'enregistrement de la composante n\'a pas pu etre effectuée.', 'error');
                                    self.payload.idComposante = '';
                                }
                            })
                            .catch((error) => {
                                swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'error');
                                self.payload.idComposante = '';
                            })
                            .finally(() => self.$loading(false));
                        })
                        .catch((error) => {
                            swal('Information!', 'Erreur lors de la génération de l\'ID composante : ' + error, 'error');
                            console.error('Erreur lors de la génération de l\'ID composante :', error);
                        })
                        .finally(() => self.$loading(false));
                    }
                });
            }else{
                console.log("Editer", self.payload);
                swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir modifier la composante ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Modifier",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
                }, function(result) {
                    if (result === true) {
                        self.$loading(true);
                        self.$http.put('/composantes/' + self.payload.idComposante, self.payload)
                        .then(({data}) => {
                            if(data){
                                swal('Information!', 'Composante modifiée avec succès.', 'success');
                                self.initPayload();
                                self.onSearch();
                                self.showList = true;
                            }else{
                                swal('Information!', 'La modification de la composante n\'a pas pu etre effectuée. Il semble que la composante n\'existe pas.', 'warning');
                                //self.payload.idComposante = '';
                            }
                        })
                        .catch((error) => {
                            swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
                        })
                        .finally(() => self.$loading(false));
                    }
                });
            }
        },
        submitPartial(){
            const self = this;
            self.$loading(true);
            if (!self.champsObligatoiresValides()) {
                self.soumissionTentée = true;
                console.log('Veuillez remplir les champs obligatoires.');
                swal('Information!', 'Veuillez remplir les champs obligatoires avant de sauvegarder. Vérifiez les champs en rouge ou les champs avec astérisque (*).', 'warning');
                return self.$loading(false);
            }
            self.$loading(false);
            console.log(self.payload);
            console.log('Sauvegarde partielle de la composante', self.payload.currentStep);
            self.payload.initTermine = 0;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir lancer la sauvegarde partielle de la composante ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Sauvegarder",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    if (self.payload.idComposante) {
                        console.log('Je lance une modification', self.payload.idComposante);
                        self.$http.put('/composantes/' + self.payload.idComposante, self.payload)
                            .then(({data}) => {
                                if(data){
                                    swal('Information!', 'Modification de la sauvegarde partielle de la composante effectuée avec succès.', 'success');
                                    self.initPayload();
                                    self.onSearch();
                                    self.showList = true;
                                }else{
                                    swal('Information!', 'La modification de la composante n\'a pas pu etre effectuée. Il semble que la composante n\'existe pas.', 'error');
                                    //self.payload.idComposante = '';
                                }
                            })
                            .catch((error) => {
                                swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'error');
                            })
                            .finally(() => self.$loading(false));
                    } else {
                        console.log('Je lance un nouvel enregistrement');
                        self.$http.get('/composantes/generer/' + self.payload.idClasseur.idClasseur)
                        .then(({data}) =>{
                            self.$loading(true);
                            self.idC = data.idComposante;
                            self.payload.idComposante = self.idC;
                            self.$http.post('/composantes', self.payload)
                                .then(({data}) => {
                                    if(data){
                                        swal('Information!', 'Sauvegarde partielle de la composante effectuée avec succès.', 'success');
                                        self.initPayload();
                                        self.onSearch();
                                        self.showList = true;
                                    }else {
                                        swal('Information!', 'La sauvegarde partielle de la composante n\'a pas pu etre effectuée.', 'error');
                                        self.payload.idComposante = '';
                                    }
                                })
                                .catch((error) => {
                                    swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'error');
                                    self.payload.idComposante = '';
                                })
                                .finally(() => self.$loading(false));
                        })
                        .catch((error) => {
                            swal('Information!', 'Erreur lors de la génération de l\'ID composante : ' + error, 'error');
                            console.error('Erreur lors de la génération de l\'ID composante :', error);
                        })
                        .finally(() => self.$loading(false));
                    }
                }
            });
        },
        drop(item){
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir supprimer la composante ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Supprimer",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/composantes/' + item.idComposante)
                    .then(({data}) => {
                            swal('Information!', 'Composante supprimée avec succès.', 'success');
                            self.onSearch();
                            self.showList = true;
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'error');
                    })
                    .finally(() => self.$loading(false));
                }
            });
        },
        showDetail(item){
            this.$loading(true);
            this.composante = {...item};
            $('#detail-composante').modal('show');
            this.$loading(false);
        },
        hideModal1() {
            $('#detail-composante').modal('hide');
        },
        hideModal2() {
            $('#planification-composante').modal('hide');
        },
        hideModal3() {
            $('#liaison-composanteP4w').modal('hide');
        },
        handleProjetPag(value){
            console.log(value);
            this.$http.get('/projetPag/action/' + value.idAction)
            .then(({data}) =>{
                this.$loading(true);
                this.projetsPag = data;
                this.payload.idProjetPag = {};
            })
            .catch((error) => {
                swal('Information!', 'Une erreur est survenue lors de la recherche. ' + error, 'error');
            })
            .finally(() => this.$loading(false));
        },
        handleSsProjetPag(value){
            console.log(value);
            this.$http.get('/sousProjetPag/projet/' + value.idProjetPag)
            .then(({data}) =>{
                this.$loading(true);
                this.sousProjetsPag = data;
                this.payload.idSsProjPag = {};
            })
            .catch((error) => {
                swal('Information!', 'Une erreur est survenue lors de la recherche. ' + error, 'error');
            })
            .finally(() => this.$loading(false));
        },
        calculTaux(){
            const total = this.payload.planificationList.reduce((sum, val) => {
                            return sum + (Number(val.tepPlanifie) || 0);
                        }, 0);
            this.payload.tepPlanifie = total;
        },
        calculAmountCapex(){
            //const total = Object.values(value).reduce((sum, val) => sum + (Number(val) || 0), 0);
            const total = this.payload.planificationList.reduce((sum, val) => {
                            return sum + (Number(val.capexEstime) || 0);
                        }, 0);
            this.payload.capex = total;
        },
        calculAmountOpex(){
            const total = this.payload.planificationList.reduce((sum, val) => {
                            return sum + (Number(val.opexEstime) || 0);
                        }, 0);
            this.payload.opex = total;
        },
        calculTaux2(){
            const total = this.planifications.reduce((sum, val) => {
                            return sum + (Number(val.tepPlanifie) || 0);
                        }, 0);
            this.totalTepPlanifie = total;
        },
        calculAmountCapex2(){
            //const total = Object.values(value).reduce((sum, val) => sum + (Number(val) || 0), 0);
            const total = this.planifications.reduce((sum, val) => {
                            return sum + (Number(val.capexEstime) || 0);
                        }, 0);
            this.totalCapexEstime = total;
        },
        calculAmountOpex2(){
            const total = this.planifications.reduce((sum, val) => {
                            return sum + (Number(val.opexEstime) || 0);
                        }, 0);
            this.totalOpexEstime = total;
        },
        handleTepGlobal(value){
            console.log(value);
            switch (value) {
                case '0':
                    this.payload.statut = this.statutComposantes[0];
                    break;
                case '1':
                    this.payload.statut = this.statutComposantes[2];
                    break;
                case 'x':
                    this.payload.statut = this.statutComposantes[3];
                    break;
                default:
                    this.payload.statut = this.statutComposantes[1];
                    break;
            }
        },
        handleStatut(value){
            console.log(value);
            switch (value.statut) {
                case '00': // A planifier
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                case '01': // Planifié
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'ACTIF');
                    break;
                case '02': // En cours
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'ACTIF');
                    break;
                case '03': // Terminé
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'CLOTURE');
                    break;
                case '04': // Annulé
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                case '05': // A confirmer
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'A_CONFIRMER');
                    break;
                case '06': // Doublon
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'DOUBLON');
                    break;
                case '07': // Suspendu
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                case 'A supprimer': // A supprimer
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'A_SUPPRIMER');
                    break;
                case 'N/A': // N/A
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'NA');
                    break;
                default: // A planifier
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
            }  
        },
        calcdate(obj) {
            var dt = new Date(obj);
            dt.setDate(dt.getDate() + 1);
            return dt;
        },
        handleSelectClasseur(item){
            this.$loading(true);
            this.$http.get('/composantes/classeurs/' + item.idClasseur)
            .then(({data}) =>{
                if (data) {
                    console.log(data);
                    this.items = data;
                    this.lesComposantes = data?.content;
                } else {
                    this.lesComposantes = [];
                    swal('Information!', 'Aucune composante disponible pour ce classeur.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors du chargement des composantes : ' + error, 'warning');
                console.error('Erreur lors du chargement des composantes :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        addTagClasseur(item) {
            this.$loading(true);
            if(this.tagsClasseurs.find(tag => tag.idClasseur === item.idClasseur)) return;
            this.tagsClasseurs.push(item);
            this.$loading(false);  
        },
        removeTagClasseur(item) {
            this.tagsClasseurs.splice(this.tagsClasseurs.indexOf(item), 1);
        },
        handleGenererID(item){
            this.$loading(true);
            this.$http.get('/composantes/generer/' + item.idClasseur)
            .then(({data}) =>{
                if (data.idComposante) {
                    this.payload.idComposante = data.idComposante;
                } else {
                    this.payload.idComposante = '';
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors de la génération de l\'ID composante : ' + error, 'warning');
                console.error('Erreur lors de la génération de l\'ID composante :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        handleGetExercices(dateDebut, dateFin){
            if(!dateDebut || !dateFin) return;
            this.$loading(true);
            var startYear = new Date(dateDebut).getFullYear();
            var endYear = new Date(dateFin).getFullYear();
            console.log(startYear, endYear);
            this.$http.get(`/exercice/filter/${startYear}/${endYear}`)
            .then(({data}) =>{
                this.exercices = [];
                this.payload.planificationList = [];
                this.exercices = data;

                // this.exercices.forEach((item, index) => {
                //     this.$set(this.montantsCapex, item?.annee, 0);
                //     this.$set(this.montantsOpex, item?.annee, 0);
                //     this.$set(this.niveauxTaux, item?.annee, 0);
                // });
                this.exercices.forEach((item, index) => {
                    this.payload.planificationList.push({annee: item, tepPlanifie: 0, capexEstime: 0, opexEstime: 0});
                });
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors de la récupération des exercices : ' + error, 'error');
            })
            .finally(() => {this.$loading(false);});
        },
        statusRetardFdr(value) {
            switch (value) {
                case 'Non':
                    return 'success';
                case 'Oui':
                    return 'warning';
                default:
                    return 'warning'; //PROCESSED
            }
        },
        statusEtat(value) {
            switch (value) {
                case 'SUSPENDU':
                    return '#000000';
                case 'ANNULE':
                    return '#000000';
                case 'ACTIF':
                    return '#C6E0B4';
                case 'CLOTURE':
                    return '#8EA9DB';
                case 'DOUBLON':
                    return '#F2F2F2';
                case 'PLANIFIE':
                    return '#F2F2F2';
                case 'A_SUPPRIMER':
                    return '#F2F2F2';
                case 'NON_DEMARRE':
                    return '#F2F2F2';
                case 'A_CONFIRMER':
                    return '#F2F2F2';
                case 'PLUS':
                    return '#F2F2F2';
                case 'X':
                    return '#F2F2F2';
                case 'NA':
                    return '#F2F2F2';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        statusStatut(value) {
            switch (value) {
                case '00':
                    return '#F2F2F2';
                case '01':
                    return '#E2EFDA';
                case '02':
                    return '#C6E0B4';
                case '03':
                    return '#8EA9DC';
                case '04':
                    return '#ACB9CA';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        showPlanifications(item){
            this.$loading(true);
            this.$http.get('/planification/composante/' + item.idComposante)
            .then(({data}) =>{
                if (data.length > 0) {
                    this.planifications = data;
                    this.composante = item;
                    this.calculTaux2();
                    this.calculAmountCapex2();
                    this.calculAmountOpex2();
                    $('#planification-composante').modal('show');
                } else {
                    this.planifications = [];
                    swal('Information!', 'Aucune planification disponible pour cette composante.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors du chargement des planifications : ' + error, 'error');
                console.error('Erreur lors du chargement des planifications :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        savePlanification(id, items){
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir modifier les planifications de la composante ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Modifier",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.put(`/planification/composante/update/${id}/${self.totalTepPlanifie}/${self.totalCapexEstime}/${self.totalOpexEstime}`, items)
                    .then(({data}) =>{
                        if(data){
                            swal('Information!', 'Planification modifiée avec succès.', 'success');
                            self.onSearch();
                            self.hideModal2();
                        }else{
                            swal('Information!', 'La modification de la planification n\'a pas pu etre effectuée.', 'error');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'error');
                    })
                    .finally(() => {
                        self.$loading(false);
                    });
                }
            });
        },
        couleurMeteo(value){
            switch (value) {
                case 'Noir':
                    return '#000000';
                case 'Orange':
                    return '#FFC000';
                case 'Rouge':
                    return '#FF0000';
                case 'Vert':
                    return '#00B050';
                case 'Bleu':
                    return '#4472C4';
                case 'Blanc':
                    return '#FFFFFF';
                default:
                    return '#FFFFFF'; //PROCESSED
            }
        },
        couleurCritere(value){
            if(parseInt(value) >= 3){
                return '#00B050';
            }else if(parseInt(value) >= 2 && parseInt(value) < 3){
                return '#FFC000';
            }else if(parseInt(value) >= 1 && parseInt(value) < 2){
                return '#FF0000';
            }else if(parseInt(value) < 1){
                return '#000000';
            }else {
                return '#FFFFFF';
            }
        },
        verifyComplexite(item){
            this.$loading(true);
            var mco = item.complexiteMco?.valeur || -1;
            var solution = item.complexiteSolution?.valeur || -1;
            var miseADispoPrerequis = item.complexiteMDispo?.valeur || -1;
            var gouvernance = item.complexiteMGouv?.valeur || -1;
            this.$http.get(`/composantes/evaluerComplexiteGlobale/${mco}/${solution}/${miseADispoPrerequis}/${gouvernance}`)
            .then(({data}) =>{
                if (data) {
                    console.log('RESULT COMPLEXITE === ', data);
                    this.payload.complexiteMiseEnOeuvre = data.complexiteGlobale;
                    this.payload.chargeTrAsinPrj = data.chargeProjet;
                    this.payload.chargeTrAsinRun = data.chargeRun;
                } else {
                    swal('Information!', 'L\'évaluation n\'a pas pu être bien faite.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors de l\'évaluation de la complexité : ' + error, 'error');
                console.error('Erreur lors de l\'évaluation de la complexité :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        verifyInteretImpact(item){
            this.$loading(true);
            console.log(item);
            var interetMetier = item.interetMetier?.valeur || -1;
            var impactJuridique = item.impactJuridique?.valeur || -1;
            var impactEnvSoc = item.impactEnvSoc?.valeur || -1;
            var interetStrategique = item.interetStrategique?.valeur || -1;
            var interetEconomique = item.interetEconomique?.valeur || -1;
            var interetPolitique = item.interetPolitique?.valeur || -1;
            this.$http.get(`/composantes/evaluerInteretImpact/${interetMetier}/${impactJuridique}/${impactEnvSoc}/${interetStrategique}/${interetEconomique}/${interetPolitique}`)
            .then(({data}) =>{
                if (data) {
                    console.log('RESULT INTERET IMPACT === ', data);
                    this.payload.interetImpact = data;
                } else {
                    swal('Information!', 'L\'évaluation n\'a pas pu être bien faite.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors de l\'évaluation de l\'interet/impact : ' + error, 'error');
                console.error('Erreur lors de l\'évaluation de l\'interet/impact :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        getObjectifStrategique(value){
            //console.log(value);
            if(value){
                this.payload.objectifStrategique = value?.objectifStrategique;
            }
        },
        showModalForLiaisonComposanteP4w(item){
            this.$loading(true);
            this.composante = {...item};
            $('#liaison-composanteP4w').modal('show');
            this.$loading(false);
        },
        saveLiaisonComposanteP4W(id, value){
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir modifier la composante P4W de la composante ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Modifier",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.post(`/composantes/liaisonComposanteP4w/${id}`, value)
                    .then(({data}) => {
                        if (data) {
                            swal('Information!', 'Liaison effectuée avec succès.', 'success');
                            self.onSearch();
                            self.hideModal3();
                        }else {
                            swal('Information!', 'Liaison non effectuée.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la liaison. ' + error, 'warning');
                    })
                    .finally(() => { self.$loading(false);});
                }
            });
        },
        showFormMeteo(item) {
            this.$router.push({ name: 'meteos' , params: { composanteItem: item, showList: false } });
        },
        showHistoriqueMeteo(item){
            this.$loading(true);
            this.composante = {...item};
            this.$http.get(`/meteo/composante/${item.idComposante}`)
            .then(({data}) =>{
                if (data.length > 0) {
                    this.meteos = data;
                    this.composante = item;
                    $('#detail-composante-meteo').modal('show');
                } else {
                    this.meteos = [];
                    swal('Information!', 'Aucune météo disponible pour cette composante.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors du chargement des météos : ' + error, 'error');
                console.error('Erreur lors du chargement des météos :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        hideModalMeteo() {
            $('#detail-composante-meteo').modal('hide');
        },
    },
    created() {
        this.onSearch();
        this.buildColumns();
        this.$http.get('/classeurs/all')
        .then(({data}) =>{
            this.classeurs = data;
        });
        this.$http.get('/p4wComposantes')
        .then(({data}) =>{
            this.p4wComposanteGuids = data;
        });
        this.$http.get('/composantes/composantesp4wDisponibles')
        .then(({data}) =>{
            this.composantesP4wDisponibles = data;
        });
        this.$http.get('/etatComposante')
        .then(({data}) =>{
            this.etatComposantes = data;
            this.columns.push({ name: 'etatComposante', description: 'Etat Composante', used: false, //type: 'text',
                    options: this.etatComposantes.map(o => ({ key: o.etat, value: o.libelle })),
                });
        });
        this.$http.get('/statutComposante')
        .then(({data}) =>{
            this.statutComposantes = data;
            this.columns.push({ name: 'statut', description: 'Statut', used: false, //type: 'text',
                    options: this.statutComposantes.map(o => ({ key: o.statut, value: o.libelle })),
                });
        });
        this.$http.get('/actionPag')
        .then(({data}) =>{
            this.actionsPag = data;
        });
        this.$http.get('/projetPag')
        .then(({data}) =>{
            this.projetsPag = data;
        });
        this.$http.get('/sousProjetPag')
        .then(({data}) =>{
            this.sousProjetsPag = data;
            this.columns.push({ name: 'idSsProjPag', description: 'Sous Projet Pag', used: false, //type: 'text',
                    options: this.sousProjetsPag.map(o => ({ key: o.idSsProjPag, value: o.nomSsProjPag })),
                });
        });
        this.$http.get('/pillierPlStrat')
        .then(({data}) =>{
            this.pillierPlStrats = data;
        });
        this.$http.get('/programmeStrat')
        .then(({data}) =>{
            this.programmeStrats = data;
        });
        this.$http.get('/degreConfidentialite')
        .then(({data}) =>{
            this.degres = data;
        });
        this.$http.get('/priorite')
        .then(({data}) =>{
            this.priorites = data;
        });
        this.$http.get('/secteurActivite')
        .then(({data}) =>{
            this.secteurActivites = data;
            this.columns.push({ name: 'secteur_activite', description: 'Secteur d\'activité', used: false, //type: 'text',
                    options: this.secteurActivites.map(o => ({ key: o.secteur, value: o.libelle })),
                });
        });
        this.$http.get('/complexiteSolution')
        .then(({data}) =>{
            this.complexiteSolutions = data;
        });
        this.$http.get('/complexiteMco')
        .then(({data}) =>{
            this.complexiteMcos = data;
        });
        this.$http.get('/complexiteMGouv')
        .then(({data}) =>{
            this.complexiteMGouvs = data;
        });
        this.$http.get('/complexiteMDispo')
        .then(({data}) =>{
            this.complexiteMDispos = data;
        });
        this.$http.get('/entite')
        .then(({data}) =>{
            this.entites = data;
            this.columns.push({ name: 'beneficiaire', description: 'Bénéficiaire (nom bénéficiaire)', used: false, //type: 'text',
                    options: this.entites.map(o => ({ key: o.entCode, value: o.entNom })),
                });
        });
        this.$http.get('/interetStrategique')
        .then(({data}) =>{
            this.interetStrategiques = data;
        });
        this.$http.get('/interetPolitique')
        .then(({data}) =>{
            this.interetPolitiques = data;
        });
        this.$http.get('/interetMetierBen')
        .then(({data}) =>{
            this.interetMetierBens = data;
        });
        this.$http.get('/interetEconomique')
        .then(({data}) =>{
            this.interetEconomiques = data;
        });
        this.$http.get('/impactJuridique')
        .then(({data}) =>{
            this.impactJuridiques = data;
        });
        this.$http.get('/impactEnvSoc')
        .then(({data}) =>{
            this.impactEnvSocs = data;
        });
        this.$http.get('/etatComposante')
        .then(({data}) =>{
            this.etatComposantes = data;
        });
        this.$http.get('/phaseExecution')
        .then(({data}) =>{
            this.phaseExecutions = data;
        });
        this.$http.get('/roleAsin')
        .then(({data}) =>{
            this.rolesAsin = data;
            this.columns.push({ name: 'roleAsin', description: 'Role ASIN (nom role)', used: false, //type: 'text',
                    options: this.rolesAsin.map(o => ({ key: o.idRole, value: o.nomRole })),
                });
        });
        this.$http.get('/poleAsin')
        .then(({data}) =>{
            this.polesAsin = data;
            this.columns.push({ name: 'poleAsin', description: 'Pole ASIN (nom pole)', used: false, //type: 'text',
                    options: this.polesAsin.map(o => ({ key: o.idPole, value: o.nomPole })),
                });
        });
        this.$http.get('/contacts')
        .then(({data}) =>{
            this.timesheetResponsables = data;
            this.chefProjets = data;
            this.columns.push({ name: 'chefProjet', description: 'Chef Projet (nom ou prénom(s))', used: false, //type: 'text',
                    options: this.chefProjets.map(o => ({ key: o.idContact, value: o.contact })),
                });
            this.spmAsins = data;
            this.pmoAsins = data;
            this.columns.push({ name: 'pmoReferent', description: 'PMO Référent (nom ou prénom(s))', used: false, //type: 'text',
                    options: this.pmoAsins.map(o => ({ key: o.idContact, value: o.contact })),
                });
            this.dafAsins = data;
            this.columns.push({ name: 'dafReferent', description: 'DAF Référent (nom ou prénom(s))', used: false, //type: 'text',
                    options: this.dafAsins.map(o => ({ key: o.idContact, value: o.contact })),
                });
            // this.cotechPresidents = data;
            // this.copilPresidents = data;
            // this.cojurPresidents = data;
        });
        this.$http.get('/exercice')
        .then(({data}) =>{
            this.exercices = data;
            this.exercices.forEach((item, index) => {
                this.payload.planificationList.push({annee: item, tepPlanifie: 0, capexEstime: 0, opexEstime: 0});
            });
        });
        this.$http.get('/statutGenerique')
        .then(({data}) =>{
            this.carteIdentites = data;
            this.fdrDispos = data;
            this.odds = data;
            this.suiviCodirAsins = data;
            this.approbations = data;
        });
        this.$http.get('/composantes/lotissement')
        .then(({data}) =>{
            this.lotissements = data;
        });
    },
}
</script>

<style>
th {
  cursor: pointer;
}
select.is-invalid {
  border: 1px solid #dc3545 !important;
  background-color: #fef2f2;
}
/* .classeur-nom {
  max-width: 220px;
  white-space: normal !important;
  word-wrap: break-word;
  word-break: break-word;
}
.composante-nom {
  max-width: 50%;
  white-space: normal !important;
  word-wrap: break-word;
  word-break: break-word;
} */
</style>